/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(7);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViewConstructor = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __webpack_require__(2);
	
	var _jsCookie = __webpack_require__(3);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** Class representing a ViewConstructor */
	var ViewConstructor = exports.ViewConstructor = function () {
	  /**
	  All components are built off of this view.
	  This extension offers
	  - toggle of loading class
	  - callback functions for manipulating css of containers
	    Parameters
	  mountId - where element will mount
	  */
	  function ViewConstructor(configObject) {
	    _classCallCheck(this, ViewConstructor);
	
	    this.mountPoint = document.getElementById(configObject.mountId);
	    this.state = {
	      generatedId: 'view-id-' + (0, _util.generateUID)(),
	      isLoading: false
	    };
	
	    this.updateState(configObject);
	
	    this.addElement();
	
	    this.cookie = _jsCookie2.default;
	
	    this.componentDidMount();
	    this.enabled = false;
	  }
	
	  /** 
	  Updates state
	  - refactor oportunity: move this method into the ViewConstructor and let all views handle their own state.
	  */
	
	
	  _createClass(ViewConstructor, [{
	    key: 'updateState',
	    value: function updateState(newState) {
	      this.state = Object.assign({}, this.state, newState);
	    }
	
	    /**
	    Fired when component mounts and is added to screen.
	    */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	
	    /**
	    # addElement
	    appends data to DOM
	      This method generates the reference ID
	    */
	
	  }, {
	    key: 'addElement',
	    value: function addElement(data) {
	      // Adding to screen does not mean it is visible
	
	      this.mountPoint.innerHTML += this.generateTemplate(data);
	      this.$ref = $('#' + this.state.generatedId);
	    }
	
	    /**
	    # generateTemplate
	    used by addElement. 
	    This wraps the div that is manipulated on/off the dom 
	    */
	
	  }, {
	    key: 'generateTemplate',
	    value: function generateTemplate(data) {
	      return '\n      <div id="' + this.state.generatedId + '" class="view" style="transform: translate3d(-100%, -100%, 0); opacity: 0;">\n        <div class="view__wrapper">\n          ' + this.render(data) + '\n        </div>\n      </div>\n    ';
	    }
	
	    /**
	    toggleLoading
	    - toggles current state of loading class
	    */
	
	  }, {
	    key: 'toggleLoading',
	    value: function toggleLoading(forceLoading) {
	      // grab reference to node element
	      var $ref = $('#' + this.state.generatedId);
	
	      // if the developer has not passed in a forced argument, check just toggle it
	      if (forceLoading === undefined) {
	        if (this.state.isLoading) {
	          $ref.show();
	          $ref.removeClass('view__loading');
	        } else {
	          $ref.hide();
	          $ref.addClass('view__loading');
	        }
	
	        this.updateState({
	          isLoading: !this.state.isLoading
	        });
	      } else {
	
	        if (forceLoading === false) {
	          // the developer forces it off
	          $ref.show();
	          $ref.removeClass('view__loading');
	          this.updateState({
	            isLoading: false
	          });
	        } else {
	          // the developer forces it on
	          $ref.hide();
	          $ref.addClass('view__loading');
	          this.updateState({
	            isLoading: true
	          });
	        }
	      }
	
	      if (this.state.isLoading) {
	        $('.loading').css({
	          display: 'flex',
	          opacity: 1
	        });
	      } else {
	        $('.loading').css({
	          opacity: 0,
	          display: 'none'
	        });
	      }
	    }
	
	    /**
	    removeElement
	    This will destroy the container that is generated when
	    */
	
	  }, {
	    key: 'removeElement',
	    value: function removeElement() {
	      this.$ref.remove();
	    }
	
	    /**
	      enterScreen
	      here's where the css entering screen or leaving screen exists
	      returns this.$ref which is a reference to the element
	    */
	
	  }, {
	    key: 'enterScreen',
	    value: function enterScreen(cb) {
	      var $ref = $('#' + this.state.generatedId);
	
	      if (typeof cb === 'function') {
	        cb($ref);
	      } else {
	        $ref.css({
	          'transform': 'translate3d(0, 0, 0)',
	          'opacity': '1',
	          'z-index': 2,
	          'pointer-events': 'auto',
	          'height': 'auto',
	          'overflow': 'visible'
	        });
	      }
	
	      this.componentDidEnter();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.enabled = true;
	    }
	
	    /**
	    cloneConsultationButton
	      Looks for consultation button that needs to be clone for landing page and appends it to button container within this view.
	      @returns cloned button
	    */
	
	  }, {
	    key: 'cloneConsultationButton',
	    value: function cloneConsultationButton() {
	      var $ref = $('#' + this.state.generatedId);
	
	      var button = $('.btn-for-gallery.fancyconsultation').clone(true);
	
	      button.removeClass('btn-for-gallery');
	
	      return button;
	    }
	
	    /**
	    leaveScreen
	      function to call when you want the component to leave the screen
	    */
	
	  }, {
	    key: 'leaveScreen',
	    value: function leaveScreen(cb) {
	      var $ref = $('#' + this.state.generatedId);
	
	      if (typeof cb === 'function') {
	        cb($ref);
	      } else {
	        $ref.css({
	          transform: 'translate3d(-100%, -100%, 0)',
	          opacity: 0,
	          'z-index': -1,
	          'pointer-events': 'none',
	          'height': '0',
	          'overflow': 'hidden'
	        });
	      }
	      this.componentDidLeave();
	    }
	    /**
	     * componentDidLeave
	     * Useful for unbinding event listeners
	     */
	
	  }, {
	    key: 'componentDidLeave',
	    value: function componentDidLeave() {
	      this.enabled = false;
	    }
	
	    /**
	    @param {string} meta title for current view
	    @param {string} meta description for current view
	      Updates both the meta title and meta description tags.
	    Also updates og meta title and description tags.
	    */
	
	  }, {
	    key: 'updateMeta',
	    value: function updateMeta(title, description) {
	      if (title !== undefined && typeof title === 'string') {
	        $('title').text(title);
	
	        var ogMetaTitle = $('meta[property="og:title"]');
	        if (ogMetaTitle.length > 0) {
	          ogMetaTitle.attr('content', title);
	        }
	      }
	
	      if (description !== undefined && typeof description === 'string') {
	        if ($('meta[name="description"]').length < 1) $('title').after('<meta name="description" content="">');
	
	        $('meta[name="description"]').attr('content', description);
	
	        var ogMetaDescription = $('meta[property="og:description"]');
	        if (ogMetaDescription.length > 0) {
	          ogMetaDescription.attr('content', description);
	        }
	      }
	    }
	
	    /**
	    @param {string} updates canonical url path
	      This checks if the meta link exists and updates it or creates a new link and appends it to the head of the document. 
	    */
	
	  }, {
	    key: 'updateCanoncial',
	    value: function updateCanoncial(canonicalUrl) {
	      if (canonicalUrl !== undefined && canonicalUrl !== '' && typeof canonicalUrl === 'string') {
	        var canoncialLink = $('link[rel="canonical"]');
	
	        if (canoncialLink.length > 0) {
	          canoncialLink.attr('href', canonicalUrl);
	        } else {
	          $('head').append('<link rel="canonical" href="' + canonicalUrl + '" />');
	        }
	      }
	    }
	
	    /**
	    You will overwrite this
	      key idea: pass in your data to your template for initial load
	    */
	
	  }, {
	    key: 'render',
	    value: function render(data) {
	      return '\n      <h1 id="title">' + (data && data.title ? data.title : "") + '</h1>\n      <div id="content">\n        ' + (data && data.content ? data.content : "") + '\n      </div>\n    ';
	    }
	  }]);
	
	  return ViewConstructor;
	}();
	
	exports.default = ViewConstructor;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateUID = generateUID;
	exports.querytoArray = querytoArray;
	exports.findThePath = findThePath;
	exports.getUrlParameter = getUrlParameter;
	exports.flattenMultiArray = flattenMultiArray;
	// http://stackoverflow.com/questions/6248666/how-to-generate-short-uid-like-ax4j9z-in-js#answer-6248722
	function generateUID() {
	  // I generate the UID from two parts here 
	  // to ensure the random number provide enough bits.
	  var firstPart = Math.random() * 46656 | 0;
	  var secondPart = Math.random() * 46656 | 0;
	  firstPart = ("000" + firstPart.toString(36)).slice(-3);
	  secondPart = ("000" + secondPart.toString(36)).slice(-3);
	  return firstPart + secondPart;
	}
	
	// converts query selector node object to an array
	// var itemsQuery = document.querySelector('.item'); 
	// var items = util.queryToArray(itemsQuery);
	function querytoArray(obj) {
	  var array = [];
	  // iterate backwards ensuring that length is an UInt32
	  for (var i = obj.length >>> 0; i--;) {
	    array[i] = obj[i];
	  }
	  return array;
	}
	
	// finds current path based on siteConfig and current routeObject
	function findThePath(allRoutes, thePathObj) {
	  // console.log('==============');
	  // console.log('current route = ', thePathObj.path);
	  var routeFound = void 0;
	
	  for (var i = 0; i < allRoutes.length; i++) {
	    var currentRoute = allRoutes[i];
	
	    // if the route exists in the string at all
	    if (currentRoute && thePathObj.path.indexOf(currentRoute.path) !== -1) {
	
	      // if route is exact
	      if (currentRoute.path === thePathObj.path) {
	        // console.log(currentRoute.path === thePathObj.path);
	        routeFound = currentRoute;
	        i = allRoutes.length + 1;
	
	        // else if route has children and one match
	      } else if (Array.isArray(currentRoute.content)) {
	        // console.log('child content is array', currentRoute.content);
	        for (var ii = 0; ii < currentRoute.content.length; ii++) {
	          var currentSubRoute = currentRoute.content[ii];
	
	          if (currentSubRoute.path === thePathObj.path) {
	            routeFound = currentSubRoute;
	            i = allRoutes.length + 1;
	            ii = currentRoute.content.length + 1;
	          }
	        }
	      }
	    }
	  }
	
	  return routeFound;
	}
	
	// https://stackoverflow.com/questions/19491336/get-url-parameter-jquery-or-how-to-get-query-string-values-in-js#answer-21903119
	function getUrlParameter(sParam) {
	  var sPageURL = decodeURIComponent(window.location.search.substring(1)),
	      sURLVariables = sPageURL.split('&'),
	      sParameterName,
	      i;
	
	  for (i = 0; i < sURLVariables.length; i++) {
	    sParameterName = sURLVariables[i].split('=');
	
	    if (sParameterName[0] === sParam) {
	      return sParameterName[1] === undefined ? true : sParameterName[1];
	    }
	  }
	};
	
	function flattenMultiArray(array, mutable) {
	  var nodes = mutable && array || array.slice(); // return a new array.
	  var flattened = [];
	
	  for (var node = nodes.shift(); node !== undefined; node = nodes.shift()) {
	    if (Array.isArray(node)) {
	      nodes.unshift.apply(nodes, node);
	    } else {
	      flattened.push(node);
	    }
	  }
	
	  return flattened;
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.0
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader = false;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function init (converter) {
			function api (key, value, attributes) {
				var result;
				if (typeof document === 'undefined') {
					return;
				}
	
				// Write
	
				if (arguments.length > 1) {
					attributes = extend({
						path: '/'
					}, api.defaults, attributes);
	
					if (typeof attributes.expires === 'number') {
						var expires = new Date();
						expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
						attributes.expires = expires;
					}
	
					// We're using "expires" because "max-age" is not supported by IE
					attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
					try {
						result = JSON.stringify(value);
						if (/^[\{\[]/.test(result)) {
							value = result;
						}
					} catch (e) {}
	
					if (!converter.write) {
						value = encodeURIComponent(String(value))
							.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
					} else {
						value = converter.write(value, key);
					}
	
					key = encodeURIComponent(String(key));
					key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
					key = key.replace(/[\(\)]/g, escape);
	
					var stringifiedAttributes = '';
	
					for (var attributeName in attributes) {
						if (!attributes[attributeName]) {
							continue;
						}
						stringifiedAttributes += '; ' + attributeName;
						if (attributes[attributeName] === true) {
							continue;
						}
						stringifiedAttributes += '=' + attributes[attributeName];
					}
					return (document.cookie = key + '=' + value + stringifiedAttributes);
				}
	
				// Read
	
				if (!key) {
					result = {};
				}
	
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all. Also prevents odd result when
				// calling "get()"
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var rdecode = /(%[0-9A-Z]{2})+/g;
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!this.json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = parts[0].replace(rdecode, decodeURIComponent);
						cookie = converter.read ?
							converter.read(cookie, name) : converter(cookie, name) ||
							cookie.replace(rdecode, decodeURIComponent);
	
						if (this.json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						if (key === name) {
							result = cookie;
							break;
						}
	
						if (!key) {
							result[name] = cookie;
						}
					} catch (e) {}
				}
	
				return result;
			}
	
			api.set = api;
			api.get = function (key) {
				return api.call(api, key);
			};
			api.getJSON = function () {
				return api.apply({
					json: true
				}, [].slice.call(arguments));
			};
			api.defaults = {};
	
			api.remove = function (key, attributes) {
				api(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * 
	 * @param {string} apiUrl - endpoint where images should be pulled from
	 * @param {object} caseData - object of data returned from the api for a single case
	 * @param {boolean} favoritedCase - whether the cases is favorited
	 */
	var CaseCard = function CaseCard(apiUrl, caseData, favoritedCase, currentCategoryName, practiceSEO) {
	    if (caseData.views.length > 0) {
	        var generateSrcSetPhoto = function generateSrcSetPhoto(singleView) {
	            var singlePhoto = '<div>';
	
	            for (var i = 0; i < singleView.images.length; i++) {
	                var currentImage = singleView.images[i];
	
	                var thumbnail = currentImage.srcset.filter(function (imageItem) {
	                    return imageItem.size.toLowerCase() === 'thumbnail';
	                })[0].path || undefined;
	                var defaultThumbnail = currentImage.srcset.filter(function (imageItem) {
	                    return imageItem.size.toLowerCase() === 'detail';
	                })[0].path || undefined;
	                var detail = currentImage.srcset.filter(function (imageItem) {
	                    return imageItem.size.toLowerCase() === 'large detail';
	                })[0].path || undefined;
	                var altText = currentCategoryName + ' ' + currentImage.type + ' Photo | ' + practiceSEO.locality.city + ', ' + practiceSEO.locality.state + ' | ' + practiceSEO.name;
	                var wrapperClass = singleView.images.length == 1 ? 'single-photo' : 'double-photo';
	
	                singlePhoto += '\n                <div class="' + wrapperClass + '">\n                    <img \n                        src="' + apiUrl + thumbnail + '" \n                        srcset="' + apiUrl + defaultThumbnail + ' 1x,\n                        ' + apiUrl + detail + ' 2x"\n                        alt="' + altText + '"\n                        title="' + altText + '" />\n                </div>\n                ';
	            }
	
	            singlePhoto += '</div>';
	            return singlePhoto;
	        };
	
	        var truncateDescription = function truncateDescription(description, truncAmount) {
	            // Currently unused
	            var descHtml = $.parseHTML(description);
	            var strippedDesc = '';
	
	            $("*", descHtml).not('p').replaceWith(function () {
	                return $(this).contents();
	            });
	            $(descHtml).each(function () {
	                strippedDesc += $.trim($(this).html()) + "~";
	            });
	            return strippedDesc.substring(0, truncAmount).replace(/~/ig, '<br />') + "...";
	        };
	
	        var firstCaseImage = caseData.views.sort(function (a, b) {
	            return a.view_number - b.view_number;
	        })[0];
	
	        window.galleryClickCard = function clickCard(element) {
	            if (!element.classList.contains('gallery-favorites') && !element.classList.contains('hide')) {
	                var currentId = element.attributes['case-id'].value;
	
	                $(element).closest('.case-card').children('#case-card-' + currentId).trigger('click');
	            }
	        };
	
	        //Populate Procedures Performed
	        var proceduresList = '';
	        caseData.case_categories.map(function (proc, i) {
	            // Append all categories for "Procedures Performed"
	            if (i !== 0 && proc.active && i < 5) proceduresList += ' &bull; ';
	            if (proc.active && i < 5) proceduresList += proc.category_name;
	        });
	        if (caseData.case_categories.length > 5) proceduresList += ' &bull; ' + (caseData.case_categories.length - 6) + ' others';
	        return '\n            <div class="case-card">\n                <a href="' + caseData.canonical_url + '" class="hide" id="case-card-' + caseData.case_id + '"></a>\n                \n                <div class="case-card__inner">\n                    <div class="case-card__image" case-id="' + caseData.case_id + '" onclick="galleryClickCard(this)">\n                        ' + generateSrcSetPhoto(firstCaseImage) + ' \n                    </div>\n                    <div class="case-card__data" case-id="' + caseData.case_id + '" onclick="galleryClickCard(this)">\n                        <div class="card-data__content">\n                            <p class="card-data__title">' + (caseData.case_title || 'Case #' + caseData.case_id) + '</p>\n                            <div class="card-data__description">' + (caseData.case_description == null ? '' : caseData.case_description) + '</div>\n                        </div>\n                        <div class="card-data__meta">\n                            <p class="card-data__procedures">Procedure(s): ' + proceduresList + '</p>' + (caseData.surgeon_name ? '<p class="card-data__surgeon">Surgeon: ' + caseData.surgeon_name : '') + ('</p>\n                        </div>\n                    </div>\n                    <div class="case-card__footer">    \n                        <p class="favorites gallery-favorites ' + (favoritedCase ? 'active' : '') + '" data-id="' + caseData.case_id + '">\n                            <span class="heart-icon ' + (favoritedCase ? 'active' : '') + '"></span>\n                            <strong class="add">Add to favorites</strong> \n                            <strong class="favorite">Favorited</strong>\n                        </p>\n                    </div>\n                </div>\n            </div>\n            ');
	    } else {
	        return '';
	    }
	};
	
	exports.default = CaseCard;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	'use strict';
	
	if (typeof Object.assign != 'function') {
	  Object.assign = function (target, varArgs) {
	    // .length of function is 2
	    'use strict';
	
	    if (target == null) {
	      // TypeError if undefined or null
	      throw new TypeError('Cannot convert undefined or null to object');
	    }
	
	    var to = Object(target);
	
	    for (var index = 1; index < arguments.length; index++) {
	      var nextSource = arguments[index];
	
	      if (nextSource != null) {
	        // Skip over if undefined or null
	        for (var nextKey in nextSource) {
	          // Avoid bugs when hasOwnProperty is shadowed
	          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
	            to[nextKey] = nextSource[nextKey];
	          }
	        }
	      }
	    }
	    return to;
	  };
	}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jsCookie = __webpack_require__(3);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var $ = window.jQuery;
	/** Class representing front-end interaction with Etna's Photo Gallery V2 API's */
	
	var PhotoGalleryApiV2 = function () {
	  /**
	  * Initialize the constructor
	  * @param {object} initialState - Include base URL where your photo gallery lives without trailing slash
	  */
	  function PhotoGalleryApiV2(initialState) {
	    _classCallCheck(this, PhotoGalleryApiV2);
	
	    this.state = {
	      url: '',
	      version: '/gallery/api/v2'
	    };
	
	    this.update(initialState);
	    this.checkForUser();
	  }
	
	  /**
	  * Update State
	  * @param {object} newState - pass in new/updated state and this will merge it with the current state of the constructor.
	  */
	
	
	  _createClass(PhotoGalleryApiV2, [{
	    key: 'update',
	    value: function update(newState) {
	      return this.state = Object.assign({}, this.state, newState);
	    }
	
	    /**
	    * Get All Categories
	    * @param {function} callback - function which will pass in all data or error message(s) returned from the API
	    * @returns either an error object or an array of objects of the categories.
	    */
	
	  }, {
	    key: 'getCategories',
	    value: function getCategories(cb) {
	      if (typeof cb === 'function') {
	        // the api requires something to be sent, therefore we will send an empty JSON object
	        $.ajax({
	          type: 'POST',
	          url: '' + this.state.url + this.state.version + '/categories',
	          contentType: 'application/json',
	          data: JSON.stringify({}),
	          error: function error(res) {
	            cb(res);
	          },
	          success: function success(res) {
	            cb(res);
	          }
	        });
	      } else {
	        console.error('You must provide a callback function for api.getCategories call');
	      }
	    }
	
	    /**
	    * Get all cases by category
	    * @param {object} requestObj - Customizable request object. It MUST contain a key of `category_id` with a value that is of type "number". The rest of the params must follow and may be rejected by the API.
	    * @param {function} callback - function which will be called and passed the data once the query completes.
	    * @returns am Object of the current category which has `case_count` number, `adult` boolean, `cases` array of case objects, `first_returned_position`, which is the sequence value of the case within the category. 
	    */
	
	  }, {
	    key: 'getCases',
	    value: function getCases(requestObj, cb) {
	      var validId = typeof requestObj.category_id === 'number';
	      var validPathname = typeof requestObj.category_url === 'string';
	
	      if ((validPathname || validId) && typeof cb === 'function') {
	        $.ajax({
	          type: 'POST',
	          url: '' + this.state.url + this.state.version + '/gallery/cases',
	          contentType: 'application/json',
	          data: JSON.stringify(requestObj),
	          error: function error(res) {
	            cb(res);
	          },
	          success: function success(res) {
	            cb(res);
	          }
	        });
	      } else {
	        console.error('api.getCases was not passed at least the (category_id || category_url) or the callback function');
	      }
	    }
	
	    /**
	    * Get single case by id.
	      @param {number} id - id of requested case number
	    @returns via callback and returns the galleries response.
	    */
	
	  }, {
	    key: 'getCaseById',
	    value: function getCaseById(caseId, cb) {
	      if (!caseId) {
	        console.error('api.getCaseById: You must pass a case id your first parameter');
	      } else {
	        $.ajax({
	          type: "GET",
	          url: '' + this.state.url + this.state.version + '/gallery/cases/' + caseId,
	          error: function error(res) {
	            cb(res);
	          },
	          success: function success(res) {
	            cb(res);
	          }
	        });
	      }
	    }
	  }, {
	    key: 'createAccount',
	    value: function createAccount(newUser, cb) {
	      if (!this.state.isBasic) {
	        var that = this;
	
	        if (!newUser.email || !newUser.password) {
	          console.error('api.createAccount requires email and password to be passed in with an object');
	        } else {
	          var newUserJson = {
	            email: newUser.email,
	            password: newUser.password
	          };
	
	          if (newUser.token) {
	            newUserJson.token = newUser.token;
	          }
	
	          $.ajax({
	            type: 'POST',
	            url: '' + this.state.url + this.state.version + '/users',
	            contentType: 'application/json',
	            data: JSON.stringify(newUserJson),
	            error: function error(res) {
	              cb(res);
	            },
	            success: function success(res) {
	              if (res && res.success) {
	                res.email = newUser.email;
	
	                that.updateUserCookie(res);
	                cb(res);
	              } else {
	                cb(res);
	              }
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'loginToAccount',
	    value: function loginToAccount(user, cb) {
	      if (!this.state.isBasic) {
	        var that = this;
	
	        if (!user.email || !user.password) {
	          console.error('api.loginToAccount requires both user email and password');
	        } else {
	          $.ajax({
	            type: 'POST',
	            url: '' + this.state.url + this.state.version + '/users/authenticate',
	            contentType: 'application/json',
	            data: JSON.stringify({
	              email: user.email,
	              password: user.password
	            }),
	            error: function error(res) {
	              cb(res);
	            },
	            success: function success(res) {
	              if (res.success) {
	                res.email = user.email;
	                that.updateUserCookie(res);
	                that.getCurrentFavorites();
	              }
	              cb(res);
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getCurrentFavorites',
	    value: function getCurrentFavorites(cb) {
	      if (!this.state.isBasic) {
	        var that = this;
	        var userCookie = _jsCookie2.default.get('gallery-user');
	
	        if (userCookie) {
	          var parsed = JSON.parse(userCookie);
	
	          $.ajax({
	            type: 'POST',
	            url: '' + this.state.url + this.state.version + '/users/favorites',
	            contentType: 'application/json',
	            data: JSON.stringify({
	              token: parsed.token
	            }),
	            error: function error(res) {
	              cb(res);
	            },
	            success: function success(res) {
	              if (res.success) {
	                that.updateUserCookie({
	                  favorites: res.favorites
	                });
	              }
	              if (typeof cb === 'function') {
	                cb(res);
	              }
	            }
	          });
	        } else {
	          console.error('user undefined');
	        }
	      }
	    }
	  }, {
	    key: 'toggleFavorite',
	    value: function toggleFavorite(id, cb) {
	      if (!this.state.isBasic) {
	        var that = this;
	        var userCookie = _jsCookie2.default.get('gallery-user');
	
	        if (userCookie && parseInt(id, 10)) {
	          var parsed = JSON.parse(userCookie);
	          var foundCase = false;
	          var action = 'add';
	
	          for (var i = 0; i < parsed.favorites.length; i++) {
	            if (parsed.favorites[i] === parseInt(id, 10)) {
	              foundCase = true;
	              action = 'remove';
	            }
	
	            if (foundCase) {
	              i = parsed.favorites.length;
	            }
	          }
	
	          $.ajax({
	            type: 'POST',
	            url: '' + this.state.url + this.state.version + '/users/favorites/' + action,
	            contentType: 'application/json',
	            data: JSON.stringify({
	              token: parsed.token,
	              case_id: parseInt(id, 10)
	            }),
	            error: function error(res) {
	              if (typeof cb === 'function') {
	                cb(res);
	              }
	            },
	            success: function success(res) {
	              if (typeof cb === 'function') {
	                cb(res);
	              }
	              that.getCurrentFavorites();
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'checkForUser',
	    value: function checkForUser() {
	      if (!this.state.isBasic) {
	        var userCookie = _jsCookie2.default.get('gallery-user');
	
	        if (userCookie) {
	          this.getCurrentFavorites();
	        }
	      }
	    }
	
	    /**
	    updateUserCookie: gallery-user
	      @param {user} object of current user returned by API. 
	      @returns object of current user with favorites filter
	    */
	
	  }, {
	    key: 'updateUserCookie',
	    value: function updateUserCookie(user, cb) {
	      if (!this.state.isBasic) {
	        var userCookie = _jsCookie2.default.get('gallery-user');
	
	        if (user === 'logout') {
	          _jsCookie2.default.remove('gallery-user');
	
	          if (typeof cb === 'function') {
	            cb();
	          }
	        } else if (userCookie) {
	          var data = JSON.parse(userCookie);
	
	          if (!data.favorites) {
	            data.favorites = [];
	          }
	
	          data = Object.assign({}, data, user);
	
	          _jsCookie2.default.remove('gallery-user');
	          _jsCookie2.default.set('gallery-user', JSON.stringify(data));
	
	          if (typeof cb === 'function') {
	            cb(data);
	          }
	        } else {
	
	          if (!user.favorites) {
	            user.favorites = [];
	          }
	
	          _jsCookie2.default.set('gallery-user', JSON.stringify(user));
	
	          if (typeof cb === 'function') {
	            cb(user);
	          }
	        }
	
	        $(window).trigger('user-changed');
	      }
	    }
	  }, {
	    key: 'createTempUserAndAddFavorite',
	    value: function createTempUserAndAddFavorite(id) {
	      if (!this.state.isBasic) {
	        var that = this;
	        if (typeof parseInt(id, 10) === 'number') {
	          $.ajax({
	            type: 'POST',
	            url: '' + this.state.url + this.state.version + '/users/favorites/add',
	            contentType: 'application/json',
	            data: JSON.stringify({
	              case_id: parseInt(id, 10)
	            }),
	            error: function error(res) {
	              if (typeof cb === 'function') {
	                cb(res);
	              }
	            },
	            success: function success(res) {
	              if (typeof cb === 'function') {
	                cb(res);
	              }
	
	              res.favorites = [];
	              that.updateUserCookie(res);
	              that.getCurrentFavorites();
	
	              // Create an account so you don't lose your favorites list!
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'updateUserAccount',
	    value: function updateUserAccount(userObject, cb) {
	      if (!this.state.isBasic) {
	        var that = this;
	
	        var response = {
	          success: false,
	          message: 'No data provided'
	        };
	        var updatedUser = {};
	
	        if (!userObject.token) {
	          response.message = 'There was an error, try logging out and back in.';
	          cb(response);
	        } else {
	          updatedUser.token = userObject.token;
	
	          if (userObject.pw) {
	            updatedUser.password = userObject.pw;
	          }
	
	          if (userObject.email) {
	            updatedUser.email = userObject.email;
	          }
	
	          $.ajax({
	            type: 'POST',
	            url: '' + this.state.url + this.state.version + '/users',
	            contentType: 'application/json',
	            data: JSON.stringify(updatedUser),
	            success: function success(res) {
	              if (res.success) {
	                if (updatedUser.email) {
	                  response.email = updatedUser.email;
	                }
	                response.success = true;
	                response.message = '';
	
	                if (updatedUser.password) {
	                  delete updatedUser.password;
	                }
	
	                updatedUser.token = res.token;
	                that.updateUserCookie(updatedUser);
	                cb(response);
	              } else {
	                response.message = res.error;
	                cb(response);
	              }
	            },
	            error: function error(res) {
	              response.message = res;
	
	              cb(response);
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'resetPassword',
	    value: function resetPassword(userObject, cb) {
	      if (!this.state.isBasic) {
	        var response = {
	          success: false,
	          message: 'No data provided'
	        };
	        var updatedUser = {};
	        if (!userObject.token) {
	          response.message = 'There was an error, try logging out and back in.';
	          cb(response);
	        } else {
	          updatedUser.token = userObject.token;
	
	          if (userObject.pw) {
	            updatedUser.password = userObject.pw;
	          }
	
	          $.ajax({
	            type: 'POST',
	            url: '' + this.state.url + this.state.version + '/users/password/reset',
	            contentType: 'application/json',
	            data: JSON.stringify(updatedUser),
	            success: function success(res) {
	              if (res.status === 'success') {
	                response.success = true;
	                response.message = '';
	
	                if (updatedUser.password) {
	                  delete updatedUser.password;
	                }
	
	                cb(response);
	              } else {
	                response.message = res.error;
	                cb(response);
	              }
	            },
	            error: function error(res) {
	              response.message = res;
	
	              cb(response);
	            }
	          });
	        }
	      }
	    }
	  }, {
	    key: 'forgotPassword',
	    value: function forgotPassword(email, cb) {
	      if (!this.state.isBasic) {
	        if (email) {
	          $.ajax({
	            type: 'POST',
	            url: '' + this.state.url + this.state.version + '/users/password/forgot',
	            contentType: 'application/json',
	            data: JSON.stringify({ email: email }),
	            success: function success(res) {
	              cb(res);
	            },
	            fail: function fail(res) {
	              cb(res);
	            }
	          });
	        }
	      }
	    }
	  }]);
	
	  return PhotoGalleryApiV2;
	}();
	
	window.Cookie = _jsCookie2.default;
	exports.default = PhotoGalleryApiV2;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(20);
	
	var _PhotoGalleryApiV = __webpack_require__(6);
	
	var _PhotoGalleryApiV2 = _interopRequireDefault(_PhotoGalleryApiV);
	
	var _index = __webpack_require__(19);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _GallerySidebar = __webpack_require__(16);
	
	var _GallerySidebar2 = _interopRequireDefault(_GallerySidebar);
	
	var _DetailsPage = __webpack_require__(15);
	
	var _DetailsPage2 = _interopRequireDefault(_DetailsPage);
	
	var _CategoryPage = __webpack_require__(14);
	
	var _CategoryPage2 = _interopRequireDefault(_CategoryPage);
	
	var _LandingPage = __webpack_require__(18);
	
	var _LandingPage2 = _interopRequireDefault(_LandingPage);
	
	var _GalleryTopBar = __webpack_require__(17);
	
	var _GalleryTopBar2 = _interopRequireDefault(_GalleryTopBar);
	
	var _login = __webpack_require__(10);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _manage = __webpack_require__(12);
	
	var _manage2 = _interopRequireDefault(_manage);
	
	var _logout = __webpack_require__(11);
	
	var _logout2 = _interopRequireDefault(_logout);
	
	var _favorites = __webpack_require__(8);
	
	var _favorites2 = _interopRequireDefault(_favorites);
	
	var _resetPassword = __webpack_require__(13);
	
	var _resetPassword2 = _interopRequireDefault(_resetPassword);
	
	var _forgotPassword = __webpack_require__(9);
	
	var _forgotPassword2 = _interopRequireDefault(_forgotPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(5);
	
	if (false) {
	  module.hot.accept();
	}
	
	window.addEventListener('DOMContentLoaded', function () {
	  var baseUrl = window.eiiGallery.baseUrl;
	  var galleryBasic = window.eiiGallery.isBasic !== undefined ? window.eiiGallery.isBasic : true;
	
	  var galleryApi = new _PhotoGalleryApiV2.default({
	    url: window.eiiGallery.api,
	    isBasic: galleryBasic
	  });
	
	  var universalConfig = {
	    api: galleryApi,
	    mountId: 'content-mount',
	    casesPerPage: 12,
	    baseUrl: baseUrl,
	    isBasic: galleryBasic
	  };
	
	  var sidebarConfig = Object.assign({}, universalConfig, {
	    mountId: 'sidebar-mount'
	  });
	  var topbarConfig = Object.assign({}, universalConfig, {
	    mountId: 'topbar-mount'
	  });
	
	  var Sidebar = new _GallerySidebar2.default(sidebarConfig);
	  var TopBar = new _GalleryTopBar2.default(topbarConfig);
	
	  var Landing = new _LandingPage2.default(universalConfig);
	  var Category = new _CategoryPage2.default(universalConfig);
	  var Details = new _DetailsPage2.default(universalConfig);
	
	  var Login = new _login2.default(universalConfig);
	  var Manage = new _manage2.default(universalConfig);
	  var Logout = new _logout2.default(universalConfig);
	  var Favorites = new _favorites2.default(universalConfig);
	  var ResetPassword = new _resetPassword2.default(universalConfig);
	  var ForgotPassword = new _forgotPassword2.default(universalConfig);
	
	  var siteConfig = {
	    useAdultNag: true,
	    mount: universalConfig.mountId,
	    baseUrl: baseUrl,
	    api: galleryApi,
	    isBasic: galleryBasic,
	    galleryTitle: window.eiiGallery.galleryTitle,
	    practice: window.eiiGallery.practice,
	    onLoad: function onLoad(state, site) {
	      Sidebar.updateState({ gallery: site, category: Category });
	      Sidebar.setGalleryBackLink(state.baseUrl);
	      Sidebar.enterScreen();
	      Favorites.updateState({ gallery: site });
	      Category.updateState({ gallery: site });
	      site.addLinkEventListeners();
	    },
	    onRouteChange: function onRouteChange(oldState, newState, completed, site) {
	      // console.log("=====================", '\n', oldState, newState, "=====================");
	      var that = this;
	
	      function updateSection(newSectionName) {
	        $('#photo-gallery').attr('data-section', newSectionName || '');
	      }
	
	      function pagesLeaveScreen() {
	        Category.leaveScreen();
	        Details.leaveScreen();
	        Landing.leaveScreen();
	        Login.leaveScreen();
	        Manage.leaveScreen();
	        Logout.leaveScreen();
	        Favorites.leaveScreen();
	        ResetPassword.leaveScreen();
	        ForgotPassword.leaveScreen();
	      }
	
	      function ripApartUrl(nextPath) {
	        var exploded = nextPath.split('/');
	
	        if (exploded[0] === '') {
	          exploded.shift();
	        }
	
	        pagesLeaveScreen();
	        switch (exploded.filter(function (path) {
	          return path.trim() !== '';
	        }).length) {
	          case 0:
	          case 1:
	          case 2:
	            // make sure sidebar is displaying all categories
	            // console.log('is landing page');
	
	            if (that.isBasic) {
	              Sidebar.enterScreen();
	              TopBar.leaveScreen();
	            } else {
	              TopBar.enterScreen();
	            }
	
	            Sidebar.isLandingPage();
	            Landing.enterScreen();
	
	            updateSection('landing');
	
	            Landing.loadSection(newState, site);
	
	            $('#photo-gallery__title').html(that.galleryTitle);
	            $('#photo-gallery__subtitle').html('');
	
	            $(window).trigger('clear-filters');
	            Sidebar.updateState({
	              addedFilters: false
	            });
	            break;
	
	          case 2:
	            // console.log(nextPath, 'should never get here since subcategories have unused parent... if so, use case 1?');
	            break;
	
	          case 3:
	            // on category page this switch:
	            // - alerts the sidebar to update to category section
	            // - Updates gallery section
	            // - tells the category component that it needs to load and it will handle it's own network request. 
	
	            // console.log('is category page');
	            // Category.enterScreen();
	
	            newState.id = undefined;
	
	            site.update({
	              currentCategoryCanonical: newState.path
	            });
	
	            if (that.isBasic) {
	              Sidebar.leaveScreen();
	            } else {
	              Sidebar.isCategoryPage(newState, site);
	            }
	
	            updateSection('category');
	
	            Category.loadSection(newState, site);
	            Category.enterScreen();
	            TopBar.enterScreen();
	            $('#photo-gallery__subtitle').html(site.state.galleryTitle);
	
	            break;
	
	          case 4:
	            updateSection('details');
	
	            var brokenPath = nextPath.split('/').filter(function (path) {
	              return path.trim() !== '';
	            });
	            var caseId = brokenPath[brokenPath.length - 1];
	
	            Details.enterScreen();
	            TopBar.enterScreen();
	            Sidebar.leaveScreen();
	
	            galleryApi.getCaseById(caseId, function (res) {
	              var detailsConfig = {
	                case: res,
	                api: galleryApi,
	                apiUrl: galleryApi.state.url,
	                gallery: site
	              };
	
	              Details.loadSection(detailsConfig);
	            });
	
	            break;
	
	          default:
	            //console.log(nextPath, exploded);
	            break;
	        }
	      }
	
	      function handleAccountUrl(url) {
	        var urlToCheck = url;
	
	        if (urlToCheck.indexOf('?') !== -1) {
	          // remove the url query
	          urlToCheck = urlToCheck.split('?')[0];
	        }
	
	        if (urlToCheck[url.length - 1] === "/") {
	          urlToCheck = urlToCheck.slice(0, -1);
	        }
	
	        updateSection('account');
	        pagesLeaveScreen();
	        Sidebar.isAccountSection();
	
	        switch (urlToCheck) {
	          case that.baseUrl + '/my-account/login':
	          case that.baseUrl + '/my-account/create':
	            Login.enterScreen();
	
	            break;
	          case that.baseUrl + '/my-account/logout':
	            galleryApi.updateUserCookie('logout');
	            Logout.enterScreen();
	            break;
	          case that.baseUrl + '/my-account/favorites':
	            Favorites.enterScreen();
	
	            break;
	          case that.baseUrl + '/my-account/forgot-password':
	            ForgotPassword.enterScreen();
	            break;
	          case that.baseUrl + '/my-account/reset-password':
	            ResetPassword.enterScreen();
	            break;
	          case that.baseUrl + '/my-account':
	            Manage.enterScreen();
	            break;
	          default:
	
	            break;
	        }
	      }
	
	      if (!this.isBasic && newState.path.indexOf('/my-account') !== -1) {
	        handleAccountUrl(newState.path);
	      } else {
	        ripApartUrl(newState.path);
	      }
	
	      completed();
	    }
	
	  };
	
	  var mySite = new _index2.default(siteConfig);
	});

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ViewConstructor2 = __webpack_require__(1);
	
	var _ViewConstructor3 = _interopRequireDefault(_ViewConstructor2);
	
	var _CaseCard = __webpack_require__(4);
	
	var _CaseCard2 = _interopRequireDefault(_CaseCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GalleryFavorites = function (_ViewConstructor) {
	    _inherits(GalleryFavorites, _ViewConstructor);
	
	    function GalleryFavorites() {
	        _classCallCheck(this, GalleryFavorites);
	
	        return _possibleConstructorReturn(this, (GalleryFavorites.__proto__ || Object.getPrototypeOf(GalleryFavorites)).apply(this, arguments));
	    }
	
	    _createClass(GalleryFavorites, [{
	        key: 'componentDidEnter',
	        value: function componentDidEnter() {
	            var user = Cookie.getJSON('gallery-user');
	            var $ref = $('#' + this.state.generatedId);
	
	            if (user) {
	                // update user details
	                if (!user.email) {
	                    $(window).trigger('show-create-account');
	                }
	
	                this.getFavoritesFromApi(user);
	                this.checkForRemovalOfCases(user);
	            } else {
	
	                this.checkForRemovalOfCases({ favorites: [] });
	                // no user found. Redirect to login page
	                $ref.find('#redirect-login').trigger('click');
	            }
	
	            $(window).bind('user-changed', this.userChanged.bind(this));
	        }
	    }, {
	        key: 'componentDidLeave',
	        value: function componentDidLeave() {
	            $(window).unbind('user-changed', this.userChanged.bind(this));
	        }
	
	        /**
	         * window event listener applied on screen enter and removed on screen leave
	         */
	
	    }, {
	        key: 'userChanged',
	        value: function userChanged() {
	            var user = Cookie.getJSON('gallery-user');
	
	            if (user) {
	                this.checkForRemovalOfCases(user);
	                this.getFavoritesFromApi(user);
	            }
	        }
	
	        /**
	         * getFavoritesFromApi
	         *    
	         * This method loops over the favorites stored in the cookie
	         * - Then it checks to see if the case exists on page
	         * -- IF it does, then it doesn't do anything
	         * -- IF the case DOESN'T exists, it will then reach out to the API for that case data && then drop it into a card and post onto the screen.
	         * 
	         * @param {object} userObject - stored in cookies
	         */
	
	    }, {
	        key: 'getFavoritesFromApi',
	        value: function getFavoritesFromApi(userObject) {
	            var that = this;
	
	            for (var i = 0; i < userObject.favorites.length; i++) {
	                var $ref = $('#' + this.state.generatedId);
	
	                if ($ref.find('.case-card__inner[case-id="' + userObject.favorites[i] + '"]').length <= 0) {
	                    this.state.api.getCaseById(userObject.favorites[i], function (response) {
	                        response.canonical_url += '?favorites=true';
	
	                        var favoriteCase = (0, _CaseCard2.default)(that.state.api.state.url, response, true);
	
	                        that.addCardToPage(favoriteCase, response.case_id);
	                    });
	                }
	            }
	        }
	
	        /** 
	         * compare current cases on page to array of cases on user object
	        */
	
	    }, {
	        key: 'checkForRemovalOfCases',
	        value: function checkForRemovalOfCases(userObject) {
	            var $ref = $('#' + this.state.generatedId);
	
	            $ref.find('.case-card__inner').each(function (index, $card) {
	                var currentId = parseInt($(this).attr('case-id'), 10);
	
	                if (!userObject.favorites.includes(currentId)) {
	                    $(this).closest('.case-card').remove();
	                }
	            });
	        }
	
	        /**
	         * addCardToPage
	         *   
	         * This first checks to see if current card already exists on page, then appends case to page.
	         * 
	         * @param {string} htmlCard - string template with Case Card
	         * @param {number} caseId - case id of case to be added to page
	         */
	
	    }, {
	        key: 'addCardToPage',
	        value: function addCardToPage(htmlCard, caseId) {
	            var $ref = $('#' + this.state.generatedId);
	            var $cardContainer = $ref.find('.case-cards');
	
	            if ($cardContainer.find('.case-card__inner[case-id="' + caseId + '"]').length < 1) {
	                $cardContainer.append(htmlCard);
	                updateIndexOrder();
	            }
	
	            function updateIndexOrder() {
	                var user = Cookie.getJSON('gallery-user');
	                var $cardContainer = $ref.find('.case-cards');
	
	                for (var i = 0; i < user.favorites.length; i++) {
	                    var currentUser = user.favorites[i];
	                    $cardContainer.find('#case-card-' + currentUser).closest('.case-card').css('order', i + 1);
	                }
	            }
	
	            this.state.gallery.addFavoriteLinkListeners();
	            this.state.gallery.addLinkEventListeners();
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return '\n    <div class="account-favorites">\n        <h2>Favorites</h2>\n\n        <div class="case-cards">\n        \n        </div>\n\n        <div class="hide redirects">\n            <a href="' + this.state.baseUrl + '/my-account/login" id="redirect-login"></a>\n        </div>\n    </div>\n    ';
	        }
	    }]);
	
	    return GalleryFavorites;
	}(_ViewConstructor3.default);
	
	exports.default = GalleryFavorites;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ViewConstructor2 = __webpack_require__(1);
	
	var _ViewConstructor3 = _interopRequireDefault(_ViewConstructor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GalleryForgotPassword = function (_ViewConstructor) {
	  _inherits(GalleryForgotPassword, _ViewConstructor);
	
	  function GalleryForgotPassword() {
	    _classCallCheck(this, GalleryForgotPassword);
	
	    return _possibleConstructorReturn(this, (GalleryForgotPassword.__proto__ || Object.getPrototypeOf(GalleryForgotPassword)).apply(this, arguments));
	  }
	
	  _createClass(GalleryForgotPassword, [{
	    key: 'componentDidEnter',
	
	    /**
	      Function fired on mount.
	        This adds event listeners for form submission and form mode change (create account or login)
	    */
	    value: function componentDidEnter() {
	      var that = this;
	      var $ref = $('#' + this.state.generatedId);
	      var errRef = $ref.find('.errors');
	      var successRef = $ref.find('.success');
	
	      $ref.find('.gallery-form-forgot-password').off().on('submit', function (e) {
	        var _this2 = this;
	
	        if (e) {
	          e.preventDefault();
	        }
	        var email = $ref.find('input[name="email"]').val();
	
	        that.state.api.forgotPassword(email, function (res) {
	          if (res.status === 'success') {
	            successRef.find('p').text('Please check your email for a link to reset your password.');
	            successRef.slideDown();
	            $(_this2).slideUp();
	          } else {
	            //console.log('fail', res);
	            errRef.find('p').text('Something');
	            $ref.find('.errors').slideDown();
	          }
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return '\n      <div class="login-container">\n        <h2>Reset Your Password</h2>\n        <div class="errors">\n          <p></p>\n        </div>\n        <div class="success">\n          <p></p>\n        </div>\n        <form class="gallery-form-forgot-password gallery-form">\n            <label for="gallery_email">\n                <span>Email:</span>\n                <input type="email" name="email" required />\n            </label>\n            <div class="login-container__button-container">\n                <button type="submit" class="gallery-btn-login">Send Reset Password Link</button>\n            </div>\n        </form>\n      <div>\n    ';
	    }
	  }]);
	
	  return GalleryForgotPassword;
	}(_ViewConstructor3.default);
	
	exports.default = GalleryForgotPassword;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ViewConstructor2 = __webpack_require__(1);
	
	var _ViewConstructor3 = _interopRequireDefault(_ViewConstructor2);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GalleryLogin = function (_ViewConstructor) {
	  _inherits(GalleryLogin, _ViewConstructor);
	
	  function GalleryLogin() {
	    _classCallCheck(this, GalleryLogin);
	
	    return _possibleConstructorReturn(this, (GalleryLogin.__proto__ || Object.getPrototypeOf(GalleryLogin)).apply(this, arguments));
	  }
	
	  _createClass(GalleryLogin, [{
	    key: 'componentDidEnter',
	
	    /**
	      Function fired on mount.
	        This adds event listeners for form submission and form mode change (create account or login)
	    */
	    value: function componentDidEnter() {
	      var that = this;
	      var $ref = $('#' + this.state.generatedId);
	
	      $ref.find('.gallery-form-login').off().on('submit', function (e) {
	        if (e) {
	          e.preventDefault();
	        }
	
	        var mode = $ref.find('.login-container').attr('data-mode');
	
	        that.handleSignIn(mode);
	      });
	
	      $ref.find('.change-form-type').off().on('click', function (e) {
	        if (e) {
	          e.preventDefault();
	        }
	        var mode = $(this).attr('data-mode');
	
	        if (mode === 'login') {
	          history.pushState(window.location.pathname, 'state', that.state.baseUrl + '/my-account/create');
	        } else {
	          history.pushState(window.location.pathname, 'state', that.state.baseUrl + '/my-account/login');
	        }
	
	        that.changeFormType(mode);
	      });
	
	      if (window.location.pathname.indexOf('create') === -1) {
	        that.changeFormType('login');
	      } else {
	        that.changeFormType('create');
	      }
	
	      $(window).trigger('hide-create-account');
	
	      var hasUser = this.cookie.getJSON('gallery-user');
	
	      if (hasUser && hasUser.email) {
	        $ref.find('#my-account-home').trigger('click');
	      }
	
	      var passwordWasReset = (0, _util.getUrlParameter)('password-reset');
	
	      if (passwordWasReset) {
	        var successRef = $('#' + this.state.generatedId + ' .success');
	        successRef.find('p').text('Your password was reset');
	        successRef.slideDown();
	
	        setTimeout(function () {
	          successRef.slideUp();
	        }, 1500);
	      }
	    }
	
	    /**
	      Handles sign in or create an account
	    */
	
	  }, {
	    key: 'handleSignIn',
	    value: function handleSignIn(mode) {
	      var $ref = $('#' + this.state.generatedId);
	      var $loginContainer = $ref.find('.login-container');
	      var errRef = $ref.find('.errors');
	
	      var email = $ref.find('input[name="gallery_email"]').val();
	      var pw = $ref.find('input[name="gallery_password"]').val();
	
	      var user = {
	        email: email,
	        password: pw
	      };
	
	      function addLoading() {
	        $loginContainer.addClass('is-loading');
	      }
	      function removeLoading() {
	        $loginContainer.removeClass('is-loading');
	      }
	      function resetForm() {
	        $loginContainer.find('input').val('');
	      }
	
	      if (mode === 'create') {
	        var confirmPw = $ref.find('input[name="gallery_password_confirm"]').val();
	        // confirm passwords match
	
	        var checkForCookie = this.cookie.getJSON('gallery-user');
	
	        if (checkForCookie && checkForCookie.token) {
	          user.token = checkForCookie.token;
	        }
	
	        // create account
	        if (confirmPw === user.password) {
	          addLoading();
	          this.state.api.createAccount(user, function (res) {
	            removeLoading();
	            if (res.success) {
	              // redirect user to manage account page
	              resetForm();
	              $ref.find('#my-account-home').trigger('click');
	            } else {
	              errRef.find('p').text(res.error);
	              $ref.find('.errors').slideDown();
	
	              if (res.error === "This email address has already been registered.") {
	                $ref.find('.login-container').addClass('show-forgot-login');
	              }
	            }
	          });
	        } else {
	          errRef.find('p').text('Those passwords don\'t match. Please type your password correctly in both fields.');
	          $ref.find('.errors').slideDown();
	        }
	      } else {
	
	        // login to account
	        addLoading();
	        this.state.api.loginToAccount(user, function (res) {
	          removeLoading();
	
	          if (res.success) {
	            // redirect user to manage account page
	            // reset forms to default
	            resetForm();
	            $ref.find('#my-account-home').trigger('click');
	          } else {
	            // show error message
	            errRef.find('p').text('The email and/or the password you entered do not match our records. Please try again or tap "I forgot my password," below.');
	            $ref.find('.errors').slideDown();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'changeFormType',
	    value: function changeFormType(mode) {
	      var $ref = $('#' + this.state.generatedId);
	      var loginContainer = $ref.find('.login-container');
	      var errRef = $ref.find('.errors');
	
	      if (mode) {
	        errRef.find('p').text('');
	        $ref.find('.errors').hide();
	
	        loginContainer.attr('data-mode', mode);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return '\n      <div class="login-container" data-mode="login">\n        <h2><span class="login">Sign In To</span><span class="create">Create</span> Your Account</h2>\n        <div class="errors">\n          <p></p>\n        </div>\n        <div class="success">\n          <p></p>\n        </div>\n        <form class="gallery-form-login gallery-form">\n          <label for="gallery_email">\n            <span>Email:</span>\n            <input type="email" name="gallery_email" required />\n          </label>\n          <label for="gallery_password">\n            <span>Password:</span>\n            <input type="password" name="gallery_password" required />\n          </label>\n          <label for="gallery_password_confirm">\n            <span>Confirm Password:</span>\n            <input type="password" name="gallery_password_confirm" />\n          </label>\n          <div class="login-container__button-container">\n            <button type="submit" class="gallery-btn-login"><span class="login">Sign In</span><span class="create">Create Account</span></button>\n          </div>\n        </form>\n        <div class="login-container__change-form-type">\n          <a class="forgot-password" href="/gallery/my-account/forgot-password"><em class="login">I forgot my password.</em></a>\n          <a class="no-account"><em class="login change-form-type" data-mode="create">I don\'t have an account.</em><em class="create change-form-type" data-mode="login">I have an account.</em></a>\n        </div>\n\n        <div class="hide">\n          <a href="/gallery/my-account/" id="my-account-home"></a>\n        </div>\n      <div>\n    ';
	    }
	  }]);
	
	  return GalleryLogin;
	}(_ViewConstructor3.default);
	
	exports.default = GalleryLogin;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ViewConstructor2 = __webpack_require__(1);
	
	var _ViewConstructor3 = _interopRequireDefault(_ViewConstructor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GalleryLogout = function (_ViewConstructor) {
	  _inherits(GalleryLogout, _ViewConstructor);
	
	  function GalleryLogout() {
	    _classCallCheck(this, GalleryLogout);
	
	    return _possibleConstructorReturn(this, (GalleryLogout.__proto__ || Object.getPrototypeOf(GalleryLogout)).apply(this, arguments));
	  }
	
	  _createClass(GalleryLogout, [{
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var _this2 = this;
	
	      setTimeout(function () {
	        $('#' + _this2.state.generatedId + ' #logging-out-account').trigger('click');
	      }, 50);
	    }
	
	    /**
	    Renders a generic template. 
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return '\n      <a href="' + this.state.baseUrl + '" id="logging-out-account">logging out... click to redirect now</a>\n    ';
	    }
	  }]);
	
	  return GalleryLogout;
	}(_ViewConstructor3.default);
	
	exports.default = GalleryLogout;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ViewConstructor2 = __webpack_require__(1);
	
	var _ViewConstructor3 = _interopRequireDefault(_ViewConstructor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GalleryManage = function (_ViewConstructor) {
	  _inherits(GalleryManage, _ViewConstructor);
	
	  function GalleryManage() {
	    _classCallCheck(this, GalleryManage);
	
	    return _possibleConstructorReturn(this, (GalleryManage.__proto__ || Object.getPrototypeOf(GalleryManage)).apply(this, arguments));
	  }
	
	  _createClass(GalleryManage, [{
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var user = Cookie.getJSON('gallery-user');
	      var $ref = $('#' + this.state.generatedId);
	
	      if (user && user.email) {
	        // update user details
	        this.updateUserDetails(user);
	      } else if (user) {
	        // redirect to login
	        // user found but no email ... means there's a temp user
	        $ref.find('#redirect-create').trigger('click');
	      } else {
	        // no user found. Redirect to login page
	        $ref.find('#redirect-login').trigger('click');
	      }
	
	      $ref.find('.gallery-form-update-email').off().on('submit', this.handleUpdateEmail.bind(this));
	      $ref.find('.gallery-form-update-password').off().on('submit', this.handleUpdatePassword.bind(this));
	
	      $ref.find('.gallery-form-update-password input').off().on('focus', function () {
	        if ($ref.find('.gallery-form-update-password').hasClass('view')) {
	          // toggleCurrentView();
	          $ref.find('.gallery-form-update-password div.change a').trigger('click');
	        }
	      });
	
	      $ref.find('.gallery-form-update-email input').off().on('focus', function () {
	        if ($ref.find('.gallery-form-update-email').hasClass('view')) {
	          $ref.find('.gallery-form-update-email div.change a').trigger('click');
	        }
	      });
	
	      $ref.find('.gallery-form div a').off().on('click', toggleCurrentView);
	
	      function toggleCurrentView() {
	        $(this).parents('.gallery-form').toggleClass('edit');
	        $(this).parents('.gallery-form').toggleClass('view');
	
	        if ($(this).parents('.gallery-form').hasClass('edit')) {
	          if ($(this).parents('.gallery-form').hasClass('gallery-form-update-password')) {
	            $(this).parents('.gallery-form').find('input[name="gallery_password"]').val('').focus();
	          } else {
	            $(this).parents('.gallery-form').find('input').focus();
	          }
	        } else {
	          $ref.find('.errors').slideUp();
	          $(this).parents('.gallery-form').find('input').blur();
	          if ($(this).parents('.gallery-form').hasClass('gallery-form-update-password')) {
	            $(this).parents('.gallery-form').find('input[name="gallery_password"]').val('NOTUPINHERE');
	          } else {
	            $(this).parents('.gallery-form').find('input').val(user.email);
	          }
	        }
	      }
	    }
	  }, {
	    key: 'updateUserDetails',
	    value: function updateUserDetails(userObj) {
	      var $ref = $('#' + this.state.generatedId);
	
	      $('.gallery-form').removeClass('edit view');
	      $('.gallery-form').addClass('view');
	
	      $ref.find('input[name="gallery_email"]').val(userObj.email);
	      $ref.find('input[name="gallery_password"]').val('GETOUTAHERE');
	    }
	  }, {
	    key: 'handleUpdateEmail',
	    value: function handleUpdateEmail(e) {
	      var that = this;
	      if (e) {
	        e.preventDefault();
	      }
	
	      var user = Cookie.getJSON('gallery-user');
	      var $ref = $('#' + this.state.generatedId);
	      var emailForm = $ref.find('input[name="gallery_email"]');
	      var emailVal = emailForm.val();
	
	      var $errorsRef = $('#' + this.state.generatedId + ' .errors');
	      var $successRef = $('#' + this.state.generatedId + ' .success');
	
	      if (emailVal !== '') {
	        this.state.api.updateUserAccount({
	          token: user.token,
	          email: emailVal
	        }, function (response) {
	          if (response.success) {
	            var updatedUser = Cookie.getJSON('gallery-user');
	            that.updateUserDetails(updatedUser);
	            emailForm.blur();
	            $errorsRef.slideUp();
	            setTimeout(function () {
	              $errorsRef.find('p').text('');
	            }, 201);
	
	            $successRef.find('p').text('Your email was updated!');
	            $successRef.slideDown();
	
	            setTimeout(function () {
	              $successRef.slideUp();
	              $successRef.find('p').text('');
	            }, 1500);
	          } else {
	            $errorsRef.find('p').text(response.message);
	            $errorsRef.slideDown();
	            $successRef.slideUp();
	          }
	        });
	      } else {
	        //console.log('email, something is wrong');
	      }
	    }
	  }, {
	    key: 'handleUpdatePassword',
	    value: function handleUpdatePassword(e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var that = this;
	
	      var user = Cookie.getJSON('gallery-user');
	      var $ref = $('#' + this.state.generatedId);
	      var pw = $ref.find('input[name="gallery_password"]');
	      var pwVal = pw.val();
	
	      var $errorsRef = $('#' + this.state.generatedId + ' .errors');
	      var $successRef = $('#' + this.state.generatedId + ' .success');
	
	      if (pwVal !== "") {
	        this.state.api.updateUserAccount({
	          token: user.token,
	          pw: pwVal
	        }, function (res) {
	          if (res.success) {
	            var updatedUser = Cookie.getJSON('gallery-user');
	            that.updateUserDetails(user);
	            pw.blur();
	            $errorsRef.slideUp();
	            setTimeout(function () {
	              $errorsRef.find('p').text('');
	            }, 201);
	
	            $successRef.find('p').text('Your password was updated!');
	            $successRef.slideDown();
	
	            setTimeout(function () {
	              $successRef.slideUp();
	              $successRef.find('p').text('');
	            }, 1500);
	          } else {
	            $errorsRef.find('p').text(res.message);
	            $errorsRef.slideDown();
	
	            $successRef.slideUp();
	            $successRef.find('p').text('');
	          }
	        });
	      } else {
	        //console.log('pw somethings wrong');
	      }
	    }
	
	    /**
	     * On input change, or change is clicked for either field
	     * - Make editable (remove .view class from form container && add .edit class to form container)
	     * - Reset password field (has temp password as placeholder)
	     * - On submit (make ajax request && reset classes to original state)
	     **/
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return '\n      <div class="manage-account">\n        <h2>Manage My Account</h2>\n\n        <div class="errors">\n          <p></p>\n        </div>\n        <div class="success">\n          <p></p>\n        </div>\n        <form class="gallery-form-update-email gallery-form view">\n          <label for="gallery_email">\n            <span>Email:</span>\n          </label>\n          <input type="email" name="gallery_email" required value="" />\n          <div>\n            <div class="change">\n              <a>Change</a>\n            </div>\n            <div class="save">\n              <button>Save</button>\n              <a></a>\n            </div>\n          </div>\n        </form>\n        <form class="gallery-form-update-password gallery-form view">\n          <label for="gallery_password">\n            <span>Password:</span>\n          </label>\n          \n          <input type="password" name="gallery_password" required />\n\n          <div>\n            <div class="change">\n              <a>Change</a>\n            </div>\n            <div class="save">\n              <button>Save</button>\n              <a></a>\n            </div>\n          </div>\n        </form>\n\n        <div class="view-favorites">\n          <div>\n            <a href="' + this.state.baseUrl + '/my-account/favorites">View Favorites</a>\n          </div>\n\n          <div>\n            <a href="' + this.state.baseUrl + '">View All Categories</a>\n          </div>\n\n          <div>\n            <a href="' + this.state.baseUrl + '/my-account/logout">Sign Out</a>\n          </div>\n        <div>\n\n        <div class="hide redirects">\n          <a href="' + this.state.baseUrl + '" id="redirect-home">Home</a>\n          <a href="' + this.state.baseUrl + '/my-account/login" id="redirect-login"></a>\n          <a href="' + this.state.baseUrl + '/my-account/create" id="redirect-create"></a>\n        </div>\n      <div>\n    ';
	    }
	  }]);
	
	  return GalleryManage;
	}(_ViewConstructor3.default);
	
	exports.default = GalleryManage;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ViewConstructor2 = __webpack_require__(1);
	
	var _ViewConstructor3 = _interopRequireDefault(_ViewConstructor2);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var GalleryResetPassword = function (_ViewConstructor) {
	    _inherits(GalleryResetPassword, _ViewConstructor);
	
	    function GalleryResetPassword() {
	        _classCallCheck(this, GalleryResetPassword);
	
	        return _possibleConstructorReturn(this, (GalleryResetPassword.__proto__ || Object.getPrototypeOf(GalleryResetPassword)).apply(this, arguments));
	    }
	
	    _createClass(GalleryResetPassword, [{
	        key: 'componentDidEnter',
	
	        /**
	          Function fired on mount.
	            This adds event listeners for form submission and form mode change (create account or login)
	        */
	        value: function componentDidEnter() {
	            var that = this;
	            var $ref = $('#' + this.state.generatedId);
	            var errRef = $ref.find('.errors');
	            var resetToken = (0, _util.getUrlParameter)('token');
	
	            if (!resetToken) {
	                $ref.find('.gallery-form-reset-password').hide();
	                $ref.find('.errors p').text('Something was missing from the address you used to get here. Please return to your email and try tapping the reset-password link again.');
	                $ref.find('.errors').slideDown();
	            }
	
	            $ref.find('.gallery-form-reset-password').off().on('submit', function (e) {
	                if (e) {
	                    e.preventDefault();
	                }
	                var setPw = $ref.find('input[name="gallery_password"]');
	                var confirmPw = $ref.find('input[name="gallery_password_confirm"]');
	
	                if (setPw.val() === confirmPw.val()) {
	                    that.state.api.resetPassword({
	                        token: resetToken,
	                        pw: setPw.val()
	                    }, function (res) {
	                        if (res.success) {
	                            setPw.val('');
	                            confirmPw.val('');
	                            $ref.find('#my-account-login').trigger('click');
	                        } else {
	                            errRef.find('p').text('There was an issue with your request. Please verify you\'ve clicked the correct link.');
	                            $ref.find('.errors').slideDown();
	                        }
	                    });
	                } else {
	                    errRef.find('p').text('Those passwords don\'t match. Please type your password correctly in both fields.');
	                    $ref.find('.errors').slideDown();
	                }
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            return '\n      <div class="login-container">\n        <h2>Reset Your Password</h2>\n        <div class="errors">\n          <p></p>\n        </div>\n        <form class="gallery-form-reset-password gallery-form">\n            <label for="gallery_password">\n                <span>Password:</span>\n                <input type="password" name="gallery_password" required />\n            </label>\n            <label for="gallery_password_confirm">\n                <span>Confirm Password:</span>\n                <input type="password" name="gallery_password_confirm" />\n            </label>\n            <div class="login-container__button-container">\n                <button type="submit" class="gallery-btn-login">Reset Password</button>\n            </div>\n        </form>\n        \n\n        <div class="hide">\n          <a href="/gallery/my-account/login?password-reset" id="my-account-login"></a>\n        </div>\n      <div>\n    ';
	        }
	    }]);
	
	    return GalleryResetPassword;
	}(_ViewConstructor3.default);
	
	exports.default = GalleryResetPassword;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ViewConstructor2 = __webpack_require__(1);
	
	var _ViewConstructor3 = _interopRequireDefault(_ViewConstructor2);
	
	var _CaseCard = __webpack_require__(4);
	
	var _CaseCard2 = _interopRequireDefault(_CaseCard);
	
	var _util = __webpack_require__(2);
	
	var _jsCookie = __webpack_require__(3);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/** Category Page renders the list of cases within the category */
	var CategoryPage = function (_ViewConstructor) {
	  _inherits(CategoryPage, _ViewConstructor);
	
	  function CategoryPage() {
	    _classCallCheck(this, CategoryPage);
	
	    return _possibleConstructorReturn(this, (CategoryPage.__proto__ || Object.getPrototypeOf(CategoryPage)).apply(this, arguments));
	  }
	
	  _createClass(CategoryPage, [{
	    key: 'componentDidMount',
	
	    /** 
	    constructor
	      Calls the ViewConstructor class and adds it's mount point.
	    @param {string} mount - id of mount element 
	    @param {object} initiated api constructor
	    */
	    value: function componentDidMount() {
	      this.updateState({
	        currentPage: 1,
	        currentRouteState: undefined,
	        currentCategory: undefined,
	        currentCategoryId: undefined,
	        cases: {},
	        casesObject: {},
	        galleryRef: undefined,
	        maxPagination: 7
	      });
	
	      this.toggleLoading(true);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      _get(CategoryPage.prototype.__proto__ || Object.getPrototypeOf(CategoryPage.prototype), 'componentDidEnter', this).call(this);
	      $(window).trigger('category-page-enter');
	    }
	
	    /**
	      This method checks the url params for current "pagination" of results. Then it will do the math to see which startingCase to use by sequence_value of the cases and the setting currently hardcoded. 
	        So if the URL says we're on page 2 and we are displaying six cases at a time, the next starting case will be sequence_value 7.
	        - fires update title function titleUpdate
	      - Runs template creation
	      - Fires off function to see if cases on page need to be updated caseUpdate. API Call here
	      - Pagination check and event listeners. 
	    */
	
	  }, {
	    key: 'loadSection',
	    value: function loadSection(newRouteState, galleryConfig) {
	      var that = this;
	
	      var title = this.getTitle(newRouteState, galleryConfig.state);
	      this.updateTitle(title);
	
	      var currentCategory = getCurrentCategoryId(newRouteState, galleryConfig.state);
	
	      var $ref = $('#' + this.state.generatedId + ' .view__wrapper');
	      $ref.find('.case-card').remove();
	
	      if (currentCategory) {
	        this.state.currentCategoryId = currentCategory.category_id;
	        this.state.currentCategory = currentCategory;
	
	        this.state.gallery = galleryConfig;
	      }
	      function getCurrentCategoryId(nextRoute, galleryState) {
	        var allSubcategories = [];
	        var currentSection = undefined;
	        var nextRouteNoParam = nextRoute.path.split('?')[0];
	
	        if (nextRouteNoParam && galleryState.categories.length) {
	          for (var i = 0; i < galleryState.categories.length; i++) {
	            allSubcategories.push(galleryState.categories[i].subcategories);
	          }
	
	          allSubcategories = (0, _util.flattenMultiArray)(allSubcategories);
	
	          var foundCategory = $.grep(allSubcategories, function (subcategory) {
	            return subcategory.category_canonical_url === decodeURI(nextRouteNoParam);
	          });
	
	          if (foundCategory.length) {
	            currentSection = foundCategory[0];
	          }
	
	          return currentSection;
	        }
	      }
	
	      if (newRouteState) {
	        this.state.currentRouteState = newRouteState;
	        this.state.galleryRef = galleryConfig;
	      }
	
	      this.getCases(function (cases) {
	        that.updateCases(cases);
	        that.state.gallery.update({
	          cases: cases
	        });
	        that.generatePagination();
	        galleryConfig.addLinkEventListeners();
	        that.toggleLoading(false);
	
	        var metaTitle = cases.category_name + ' Before & After Photo Gallery | ' + that.state.gallery.state.practice.locality.city + ', ' + that.state.gallery.state.practice.locality.state + ' | ' + that.state.gallery.state.practice.name;
	        var metaDescription = 'View before-and-after ' + cases.category_name + ' pictures of ' + that.state.gallery.state.practice.name + '\'s patients. Photos depict the excellent results patients have come to expect from ' + that.state.gallery.state.practice.name + '.';
	        that.updateMeta(metaTitle, metaDescription);
	
	        that.updateCanoncial(window.location.origin + cases.category_canonical_url);
	        $ref.find('.category__consultation__btn').html(that.cloneConsultationButton());
	        that.state.gallery.update({
	          currentCategory: cases.category_id
	        });
	      });
	    }
	
	    /**
	    updateTitle
	    - This will update the current category title. This is called when cases are returned. There's some logic here to check if the title already exists on the page. If so it will not overwrite. 
	    */
	
	  }, {
	    key: 'updateTitle',
	    value: function updateTitle(newTitle) {
	      //let titleRef = $(`#${ this.state.generatedId } .category__title`);
	      var titleRef = $('#photo-gallery__title');
	
	      if (titleRef.text() !== newTitle && newTitle && newTitle !== '') {
	        titleRef.text(newTitle);
	      }
	    }
	
	    /**
	    getTitle method
	    - This is where we see if we can preload a title. We pass in the newRouteState and the galleries current state. 
	    - Check against the gallery state to see if we can find the current gallery object. 
	      @returns either undefined if the title isn't found, or will return the string of the title.
	    */
	
	  }, {
	    key: 'getTitle',
	    value: function getTitle(newRouteState, galleryState) {
	      var allSubcategories = [];
	      var title = undefined;
	
	      if (newRouteState.path && galleryState.categories.length) {
	        for (var i = 0; i < galleryState.categories.length; i++) {
	          allSubcategories.push(galleryState.categories[i].subcategories);
	        }
	
	        allSubcategories = (0, _util.flattenMultiArray)(allSubcategories);
	
	        var foundCategory = $.grep(allSubcategories, function (subcategory) {
	          return subcategory.category_canonical_url === decodeURI(newRouteState.path);
	        });
	
	        if (foundCategory.length) {
	          title = foundCategory[0].category_name;
	        }
	
	        return title;
	      }
	
	      return title;
	    }
	
	    /**
	    Helper method which grabs the current url param for 'page'.
	      - If it doesn't exist this returns 1 // assuming the page is the first page
	    - if "all" is the value, it returns null, so we can check against it and cancel actions if need be
	    - Or it returns the value of the page
	    */
	
	  }, {
	    key: 'getCurrentPage',
	    value: function getCurrentPage() {
	      var currentPage = (0, _util.getUrlParameter)('pagination');
	
	      if (!currentPage) {
	        return 1;
	      } else if (currentPage === 'all') {
	        return null;
	      } else {
	        return parseInt(currentPage, 10);
	      }
	    }
	  }, {
	    key: 'resetCases',
	    value: function resetCases() {
	      var $ref = $('#' + this.state.generatedId + ' .view__wrapper');
	      $ref.find('.case-card').remove();
	
	      this.toggleLoading(true);
	    }
	
	    /**
	    getCases 
	    This will get the specified number of cases as defined in the options config in the constructor. 
	    @param nextRequest - should have the gallery passed object that contains the URL of the next path and possibly the id of the current category. 
	    */
	
	  }, {
	    key: 'getCases',
	    value: function getCases(cb) {
	      var that = this;
	      var currentPage = this.getCurrentPage();
	      var firstReturnedPosition = (currentPage - 1) * this.state.casesPerPage + 1;
	
	      if (this.state.currentCategoryId) {
	
	        if (currentPage === null) {
	          this.getAllCases();
	          return;
	        }
	
	        var requestObject = {
	          category_id: parseInt(this.state.currentCategoryId, 10),
	          first_returned_position: firstReturnedPosition,
	          case_count: this.state.casesPerPage
	        };
	
	        this.state.api.getCases(requestObject, function (res) {
	          that.state.cases = res;
	
	          if (typeof cb === 'function') {
	            cb(res);
	            $(window).trigger('category-page-data-loaded');
	          }
	        });
	      } else {
	        var casesRequestObject = {
	          first_returned_position: firstReturnedPosition,
	          case_count: this.state.casesPerPage,
	          category_url: decodeURI(window.location.pathname)
	        };
	
	        this.state.api.getCases(casesRequestObject, function (res) {
	          that.state.cases = res;
	          if (typeof cb === 'function') {
	            cb(res);
	            $(window).trigger('category-page-data-loaded');
	          }
	        });
	      } // else if just a path and not last path?
	    }
	
	    /**
	    This is fired when view all cases button/link is clicked. Since the API is capped at 100 cases per request, this will check to see if there are greater than 100 cases within the category and then queue up a list of requests to make and generate and append all cases to screen. 
	    
	    - checks if over 100 cases in category
	    - creates a queue of requests to make
	    - generates and appends cases to screen after each request
	    - this hides the current pagination
	    - resets the query variable. 
	    */
	
	  }, {
	    key: 'getAllCases',
	    value: function getAllCases() {
	      var _this2 = this;
	
	      if (this.state.currentCategoryId) {
	        this.toggleLoading(true);
	        var queue = [];
	        var that = this;
	
	        var amountOfRequests = Math.ceil(this.state.cases.cases_available / 100);
	
	        // hide pagination features
	        $('#' + this.state.generatedId + ' .category__pagination').fadeOut(200);
	
	        if (window.location.search.indexOf('all') === -1) {
	          // update URL in browser if it's not already there
	          history.pushState(null, null, window.location.pathname + '?pagination=all');
	
	          this.state.gallery.update({
	            currentCategoryCanonical: window.location.pathname + '?pagination=all'
	          });
	        }
	
	        var _loop = function _loop(i) {
	          var firstReturnedPosition = 1;
	
	          if (i > 0) {
	            firstReturnedPosition = i * 100 + 1;
	          }
	
	          requestObject = {
	            category_id: parseInt(_this2.state.currentCategoryId, 10),
	            first_returned_position: firstReturnedPosition,
	            case_count: 100
	          };
	
	
	          that.state.api.getCases(requestObject, function (res) {
	            that.state.cases = res;
	            that.updateCases(res, function (ref, cases, cb) {
	              if (i === 0) {
	                // if first set of response replace whatever is in the cases section
	                $(ref).html(cases);
	                that.state.gallery.addLinkEventListeners();
	                cb();
	                $(window).trigger('category-page-data-loaded');
	              } else {
	                $(ref).append(cases);
	                that.state.gallery.addLinkEventListeners();
	                cb();
	                $(window).trigger('category-page-data-loaded');
	              }
	
	              that.toggleLoading(false);
	            });
	          });
	        };
	
	        for (var i = 0; i < amountOfRequests; i++) {
	          var requestObject;
	
	          _loop(i);
	        }
	      }
	    }
	
	    /**
	    updateCases 
	    @params {object} getCasesResponse - response returned by the API
	    @params {function} callback - optional. If you pass a call back it will pass the cases ref and the cases to you. If you don't pass this, it will automatically update the on page cases itself. 
	      - This loops through all the cases returned by the api. It will check the title and update it if different. 
	    - It creates all the case cards for the returned cases
	    */
	
	  }, {
	    key: 'updateCases',
	    value: function updateCases(getCasesResponse, cb) {
	      var that = this;
	      if (getCasesResponse !== undefined) {
	        var afterUpdateCases = function afterUpdateCases() {
	          that.toggleLoading(false);
	          that.state.gallery.addLinkEventListeners();
	          _updateParentHeight();
	
	          setTimeout(function () {
	            _updateParentHeight();
	          }, 1000);
	
	          $('#' + that.state.generatedId + ' .category__cases__case').off().on('click', function (e) {
	            var targetId = $(this).attr('data-id');
	            var elementClassname = '';
	
	            if (e.target.attributes.class && e.target.attributes.class.value) {
	              elementClassname = e.target.attributes.class.value;
	            }
	
	            function wasAFavClick(currentElClassName) {
	              var allFavClasses = ['gallery-favorites', 'heart-icon', 'add', 'favorite'];
	              var wasFound = false;
	
	              for (var _i = 0; _i < allFavClasses.length; _i++) {
	                if (currentElClassName.indexOf(allFavClasses[_i]) !== -1) {
	                  wasFound = true;
	                }
	              }
	
	              return wasFound;
	            }
	
	            if (e && !wasAFavClick(elementClassname)) {
	              $('#' + targetId).trigger('click');
	            }
	          });
	        };
	
	        var _updateParentHeight = function _updateParentHeight() {
	          setTimeout(function () {
	            parentRef.animate({
	              height: ref.height()
	            }, 150);
	
	            setTimeout(function () {
	              parentRef.css({ height: 'auto' });
	            }, 200);
	          }, 250);
	        };
	
	        var parentRef = $('#' + this.state.generatedId + ' .category__cases--wrapper');
	        var ref = $('#' + this.state.generatedId + ' .category__cases');
	        var title = getCasesResponse.category_name;
	
	        var hadCasesAlready = this.state.gallery.state.cases && this.state.gallery.state.cases.category_id !== undefined;
	
	        if (this.state.gallery) {
	          this.state.gallery.update({
	            cases: getCasesResponse
	          });
	
	          // if did not have cases before... run the filters
	          if (!hadCasesAlready) {
	            $(document).trigger('update-filters');
	
	            // otherwise check if in same category, if not, run the filters
	          } else if (getCasesResponse.category_id !== parseInt(this.cookie.get('gallery--currentCategory'), 10)) {
	            $(document).trigger('update-filters');
	          }
	
	          this.cookie.set('gallery--currentCategory', that.state.gallery.state.cases.category_id);
	        }
	
	        this.updateTitle(title);
	
	        var caseTemplates = '';
	        var filteredCases = getCasesResponse.cases;
	
	        var cases = filteredCases.sort(function (a, b) {
	          return a.sequence_value - b.sequence_value;
	        });
	        var currentUserCookie = _jsCookie2.default.getJSON('gallery-user');
	
	        for (var i = 0; i < cases.length; i++) {
	          var currentCase = cases[i];
	          var isAFavoriteCase = currentUserCookie && currentUserCookie.favorites.includes(currentCase.case_id);
	          caseTemplates += (0, _CaseCard2.default)(this.state.api.state.url, currentCase, isAFavoriteCase, this.state.gallery.state.cases.category_name, this.state.gallery.state.practice);
	        }
	
	        parentRef.css({ height: ref.height() });
	
	        if (typeof cb === 'function') {
	
	          cb(ref, caseTemplates, afterUpdateCases);
	        } else {
	          ref.html(caseTemplates);
	          afterUpdateCases();
	        }
	      } else {
	        return '';
	      }
	    }
	
	    /**
	    Category Pagination.
	    This gets current page variable from URL, if not defined, it will be page 1. 
	    if there are less cases in the cases object than there are casesPerPage, no pagination will display. 
	    */
	
	  }, {
	    key: 'generatePagination',
	    value: function generatePagination() {
	      var that = this;
	      var $paginationRef = $('#' + this.state.generatedId + ' .category__pagination');
	      var currentPage = this.getCurrentPage();
	      var paginationHtml = '';
	
	      if (currentPage === null) {
	        return;
	      }
	
	      var amountOfCases = this.state.gallery.state.cases.cases_available;
	      var displayedCases = this.state.casesPerPage;
	
	      var maxNumberOfPages = Math.ceil(amountOfCases / displayedCases); // if we have 18 cases and cases to be shown are 6, then create three buttons. 
	
	      var amountOfCasesAvailable = this.state.gallery.state.cases.cases_available;
	
	      if ((0, _util.getUrlParameter)('filters')) {
	        var totalCaseCount = 0;
	
	        this.state.gallery.state.cases.filters.map(function (filter, index) {
	          if (filter.active) {
	            filter.filter_values.map(function (filterVal) {
	              if (filterVal.selected) {
	                totalCaseCount += filterVal.case_count;
	              }
	            });
	          }
	        });
	
	        amountOfCasesAvailable = totalCaseCount;
	      }
	
	      if (this.state.gallery.state.cases.cases_available && amountOfCasesAvailable > this.state.casesPerPage) {
	
	        paginationHtml += '<div class="category__pagination__count">Page &nbsp;<span class="category__pagination__count__current">' + currentPage + '</span>&nbsp;of&nbsp;' + maxNumberOfPages + '</div>';
	        // adding "previous" button
	        paginationHtml += '<div class="category__pagination__buttons"><span class="category__pagination__button-functional prev" data-value="prev">&nbsp;</span>';
	
	        for (var i = 0; i < maxNumberOfPages; i++) {
	          var className = '';
	          if (currentPage - 1 === i) {
	            className = 'active';
	          }
	          paginationHtml += '<span class="' + className + ' category__pagination__button" data-pagination="' + (i + 1) + '">' + (i + 1) + '</span>';
	
	          // if second button add hidden ellipses || if second from last
	          if (i === 1 || i === maxNumberOfPages - 2) {
	            paginationHtml += '<span class="ellipses category__pagination__button disabled" style="display: none;">...</span>';
	          }
	        }
	
	        // adding "next" button
	        paginationHtml += '<span class="category__pagination__button-functional next" data-value="next">&nbsp;</span></div>';
	
	        paginationHtml += '<div class="category__pagination__all">View All</div>';
	      }
	
	      $paginationRef.html(paginationHtml);
	
	      this.handleVisiblePagination();
	
	      $paginationRef.find('.category__pagination__button').off().on('click', handlePagniationClick);
	      $paginationRef.find('.category__pagination__button-functional').off().on('click', handleFunctionalPaginationClick);
	      $paginationRef.find('.category__pagination__all').off().on('click', handleViewAllClick);
	
	      function handleFunctionalPaginationClick(e) {
	        if (e) {
	          e.preventDefault();
	        }
	
	        var type = $(this).attr('data-value');
	        var currentPage = parseInt((0, _util.getUrlParameter)('pagination'), 10) || 1;
	
	        switch (type) {
	          case "prev":
	            if (currentPage - 1 >= 1) {
	              var newPage = currentPage - 1;
	
	              that.toggleLoading(true);
	              that.updatePaginationAndGetCases(newPage);
	            }
	            break;
	
	          case "next":
	            if (currentPage + 1 <= maxNumberOfPages) {
	              var _newPage = currentPage + 1;
	
	              that.toggleLoading(true);
	              that.updatePaginationAndGetCases(_newPage);
	            }
	            break;
	          default:
	            break;
	        }
	      }
	
	      function handlePagniationClick(e) {
	        if (e) {
	          e.preventDefault();
	        }
	
	        var newPage = $(this).attr('data-pagination');
	
	        if (newPage && !$(this).hasClass('active')) {
	          that.toggleLoading(true);
	          that.updatePaginationAndGetCases(newPage);
	        }
	      }
	
	      function handleViewAllClick(e) {
	        if (e) {
	          e.preventDefault();
	        }
	
	        $(window).trigger('pagination-change');
	        that.getAllCases();
	      }
	    }
	
	    /**
	      handleVisiblePagination
	      This method will append/remove ellipses based on current page
	    */
	
	  }, {
	    key: 'handleVisiblePagination',
	    value: function handleVisiblePagination() {
	      var that = this;
	      var buttonCount = $('#' + that.state.generatedId + ' .category__pagination__buttons').children();
	      var currentPage = parseInt((0, _util.getUrlParameter)('pagination'), 10) || 1;
	
	      // not counting the ellipses in this check
	      var amountOfNextToButtons = $(window).width() > 1024 ? 2 : 1;
	
	      if (buttonCount.length - 2 - amountOfNextToButtons > that.state.maxPagination) {
	        buttonCount.each(function (index, button) {
	          // if not first or last
	          if (index !== 1 && index !== buttonCount.length - 2) {
	            var currentButtonPage = $(button).attr('data-pagination');
	
	            // if current button has the data-page attribute
	            if (currentButtonPage) {
	              currentButtonPage = parseInt(currentButtonPage, 10);
	
	              // if not the first four cases
	              if (currentPage < 5 && currentButtonPage < 5) {
	                $(button).show();
	
	                // if within 2 of the current page button will be displayed
	              } else if (Math.abs(currentButtonPage - currentPage) <= amountOfNextToButtons) {
	                $(button).show();
	              } else {
	                $(button).hide();
	              }
	            }
	          }
	        });
	
	        // if the second page is hidden add/show ellipses button
	        if ($(buttonCount[2]).is(':hidden')) {
	          $(buttonCount[3]).show();
	        } else {
	          $(buttonCount[3]).hide();
	        }
	
	        // if the 3rd from last clickable button is hidden, it will show that last ellipses. 
	        if ($(buttonCount[buttonCount.length - 4]).is(':hidden')) {
	          $(buttonCount[buttonCount.length - 3]).show();
	
	          // otherwise it will hide the ellipses
	        } else {
	          $(buttonCount[buttonCount.length - 3]).hide();
	        }
	      }
	    }
	
	    /**
	      There are three functional methods for handling pagination events. All which end where we need to update page query in url, fetch cases and get cases. Moving duplicate code into shared functional method. 
	    */
	
	  }, {
	    key: 'updatePaginationAndGetCases',
	    value: function updatePaginationAndGetCases(newPage) {
	      var _this3 = this;
	
	      var that = this;
	      var $paginationRef = $('#' + this.state.generatedId + ' .category__pagination');
	      var $paginationButtons = $paginationRef.find('.category__pagination__button');
	
	      $paginationRef.find('.category__pagination__count__current').text(newPage);
	      // removing pagination active class and adding it to the appropriate button.
	      $paginationButtons.removeClass('active');
	      $paginationButtons.each(function (index, button) {
	        if ($(button).attr('data-pagination') === newPage.toString()) {
	          $(button).addClass('active');
	        }
	      });
	
	      history.pushState(null, null, window.location.pathname + '?pagination=' + newPage);
	
	      if (that.state.gallery) {
	        that.state.gallery.update({
	          currentCategoryCanonical: window.location.pathname + '?pagination=' + newPage
	        });
	      }
	
	      that.handleVisiblePagination();
	
	      $(window).trigger('pagination-change');
	
	      that.getCases(function (theCases) {
	        that.updateCases(theCases);
	
	        that.state.gallery.update({
	          cases: theCases
	        });
	        that.state.galleryRef.addLinkEventListeners();
	        _this3.toggleLoading(false);
	      });
	    }
	
	    /**
	     Overrides ViewConstructor's render method which renders a generic template. Since this page relies on the API other functions update the view.
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return '\n        <div class="category">\n            <p><strong><em>*Keep in mind that each patient is unique and your results may vary.</em></strong></p>\n            <hr />\n            <div class="category__cases--wrapper">\n                <div class="category__cases"></div>\n            </div>\n            <div class="category__consultation__btn"></div>\n            <div class="category__pagination"></div>\n            <div class="category__links" style="display: none;"></div>\n        </div>\n        ';
	    }
	  }]);
	
	  return CategoryPage;
	}(_ViewConstructor3.default);
	
	exports.default = CategoryPage;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ViewConstructor2 = __webpack_require__(1);
	
	var _ViewConstructor3 = _interopRequireDefault(_ViewConstructor2);
	
	var _jsCookie = __webpack_require__(3);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/** class representing the details page */
	var DetailsPage = function (_ViewConstructor) {
	  _inherits(DetailsPage, _ViewConstructor);
	
	  function DetailsPage() {
	    _classCallCheck(this, DetailsPage);
	
	    return _possibleConstructorReturn(this, (DetailsPage.__proto__ || Object.getPrototypeOf(DetailsPage)).apply(this, arguments));
	  }
	
	  _createClass(DetailsPage, [{
	    key: 'componentDidMount',
	
	
	    /**
	    componentDidMount - override method
	    */
	    value: function componentDidMount() {
	      this.updateState({
	        apiUrl: '',
	        prevCase: {},
	        nextCase: {}
	      });
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      _get(DetailsPage.prototype.__proto__ || Object.getPrototypeOf(DetailsPage.prototype), 'componentDidEnter', this).call(this);
	      this.resetCase();
	      $(window).trigger('details-page-enter');
	    }
	  }, {
	    key: 'resetCase',
	    value: function resetCase() {
	      var $ref = $('#' + this.state.generatedId);
	      var mainImage = $ref.find('.details__main__img img');
	
	      if (mainImage) {
	        mainImage.attr('src', '');
	        $ref.find('.details__others__photo').remove();
	      }
	    }
	
	    /**
	    @param {state} - can contain the case, api, gallery
	    If the state includes a case, this will imediately render it, otherwise it create a request via the API for the case id specified in the URL, then it will refire this same method with the case returned from the API as part of it's parameter. 
	    */
	
	  }, {
	    key: 'loadSection',
	    value: function loadSection() {
	      var _this2 = this;
	
	      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      var that = this;
	
	      this.updateState(state);
	
	      if (this.state.case) {
	
	        var currentCategoryName = '';
	        if (this.state.case !== undefined) {
	          var canonical_url = this.state.case.canonical_url;
	
	          this.state.case.case_categories.map(function (category) {
	            if (canonical_url.indexOf(category.category_canonical_url) !== -1) {
	              currentCategoryName = category.category_name;
	            }
	          });
	          var metaTitle = currentCategoryName + ' Before & After Photos Patient ' + this.state.case.case_id + ' | ' + this.state.gallery.state.practice.locality.city + ', ' + this.state.gallery.state.practice.locality.state + ' | ' + this.state.gallery.state.practice.name;
	          var metaDescription = 'View ' + currentCategoryName + ' before-and-after photos of ' + this.state.gallery.state.practice.name + '\'s patient ' + this.state.case.case_id;
	
	          this.updateMeta(metaTitle, metaDescription);
	          that.updateCanoncial(window.location.origin + this.state.case.canonical_url);
	        }
	
	        var galleryUser = _jsCookie2.default.getJSON('gallery-user');
	
	        var isAFavoriteCase = false;
	
	        if (galleryUser) {
	          galleryUser.favorites.map(function (singleCase) {
	            if (parseInt(singleCase, 10) === _this2.state.case.case_id) {
	              isAFavoriteCase = true;
	            }
	          });
	        }
	
	        var templateContent = {
	          title: this.state.case.case_title || (currentCategoryName !== undefined ? currentCategoryName + ' ' : '') + 'Case ' + this.state.case.case_id,
	          photos: this.generateSrcsetPhotos(this.state.case.views),
	          attr: this.generateAttributeDetails(this.state.case.case_attributes),
	          description: this.state.case.case_description ? this.state.case.case_description : '',
	          video: this.state.case.case_video,
	          id: this.state.case.case_id,
	          isAFavoriteCase: isAFavoriteCase
	        };
	        if (templateContent.attr === '' && templateContent.description === '') $('.details__attributes').slideUp();else $('.details__attributes').slideDown();
	
	        this.template(templateContent);
	        this.setMainImage();
	        if (this.state.case.sequence_value !== undefined) {
	          this.getPreviousAndNextCase();
	        } else {
	          this.getThisCategoryCases();
	        }
	      } else {
	        var brokenPath = window.location.pathname.split('/');
	        var caseId = brokenPath[brokenPath.length - 1];
	
	        this.state.api.getCaseById(caseId, function (res) {
	          that.loadSection({
	            case: res
	          });
	        });
	      }
	    }
	
	    /**
	      This will only get fired when the details page is loaded while the user has not gone down the normal route. e.g. user it linked to a case page.
	        A) This will do is make a network request to the API and for all cases witin the category (10 at a time), and loop through the cases being returned. 
	      A 1) If the case doesn't exist within the returned amount of case it will make another request incrementing the current returned position and run through step A again.
	      A 2) IF case was found, it will update the current state with the returned case and category ID then reload the current section. 
	        Why is this necessary? When I make a targeted request to the API for a single case, it doesn't return the sequence value of the current case. I need to call this in order to determine if the "prev/next" buttons should display. 
	    */
	
	  }, {
	    key: 'getThisCategoryCases',
	    value: function getThisCategoryCases() {
	      var that = this;
	      var categoryUrl = that.state.gallery.state.currentCategoryCanonical;
	      if (categoryUrl === undefined) {
	        var windowPathname = window.location.pathname.split('/');
	
	        if (windowPathname[windowPathname.length - 1] === "") {
	          windowPathname.pop();
	        }
	
	        if (typeof parseInt(windowPathname[windowPathname.length - 1], 10) === 'number') {
	          windowPathname.pop();
	        }
	
	        categoryUrl = windowPathname.join('/');
	      };
	
	      var reqObj = {
	        category_url: categoryUrl,
	        first_returned_position: 1,
	        case_count: 100
	      };
	      var urlOfCurrentCase = window.location.pathname;
	      var urlSplit = urlOfCurrentCase.split('/');
	
	      if (urlSplit[urlSplit.length - 1] === '') {
	        urlSplit.pop();
	        urlOfCurrentCase = urlSplit.join('/');
	      }
	      getCurrentCase(reqObj);
	
	      function getCurrentCase(request) {
	        that.state.api.getCases(request, function (res) {
	          if (that.enabled && res && res.case_count) {
	            var cases = res.cases;
	            var foundCase = false;
	
	            for (var i = 0; i < cases.length; i++) {
	              var currentCase = cases[i];
	              if (currentCase.canonical_url === urlOfCurrentCase) {
	                foundCase = true;
	                that.updateState({
	                  case: currentCase
	                });
	                that.state.gallery.update({ cases: res });
	              }
	            }
	
	            if (foundCase) {
	              that.loadSection();
	            } else {
	              reqObj.first_returned_position += reqObj.case_count;
	              getCurrentCase(reqObj);
	            }
	          }
	        });
	      }
	    }
	
	    /**
	    Prerendering! Based on the current category and case, this will reach out to the API on load (after initial data of page has loaded) and get the prev/next cases. We can prerender here because we want the user to through the cases
	    */
	
	  }, {
	    key: 'getPreviousAndNextCase',
	    value: function getPreviousAndNextCase() {
	      var _this3 = this;
	
	      var that = this;
	      var currentCategory = this.state.currentCategory || this.state.gallery.state.cases.category_id;
	      var currentCaseSequence = this.state.case.sequence_value;
	
	      var isFavorites = (0, _util.getUrlParameter)('favorites');
	
	      if (isFavorites) {
	        var galleryUser = _jsCookie2.default.getJSON('gallery-user');
	        var currentCaseIndex = galleryUser.favorites.indexOf(this.state.case.case_id);
	
	        var nextFavCaseRequest = galleryUser.favorites[currentCaseIndex + 1];
	        var prevFavCaseRequest = galleryUser.favorites[currentCaseIndex - 1];
	
	        if (nextFavCaseRequest) {
	          this.state.api.getCaseById(nextFavCaseRequest, function (res) {
	            that.updateState({
	              nextCase: res
	            });
	          });
	        } else {
	          this.updateState({
	            nextCase: undefined
	          });
	        }
	
	        if (prevFavCaseRequest) {
	          this.state.api.getCaseById(prevFavCaseRequest, function (res) {
	            that.updateState({
	              prevCase: res
	            });
	          });
	        } else {
	          this.updateState({
	            prevCase: undefined
	          });
	        }
	      } else {
	        var nextCaseRequest = {
	          category_id: currentCategory,
	          first_returned_position: currentCaseSequence + 1,
	          case_count: 1
	        };
	
	        var prevCaseRequest = {
	          category_id: currentCategory,
	          first_returned_position: currentCaseSequence - 1,
	          case_count: 1
	        };
	
	        this.state.api.getCases(nextCaseRequest, function (res) {
	          if (_this3.enabled && res.case_count === 1) {
	            that.updateState({
	              nextCase: res.cases[0]
	            });
	          }
	        });
	        this.state.api.getCases(prevCaseRequest, function (res) {
	          if (_this3.enabled && res.case_count === 1) {
	            that.updateState({
	              prevCase: res.cases[0]
	            });
	          }
	        });
	      }
	    }
	
	    /**
	      Here will be where ALL the event listeners will be added when this page loads. 
	      - It is responsable for when the user selects the "others" and will make it the "main" phone. 
	      - This also binds the "prev/next" buttons to  fire the handleDetailsNavigation method with the current action.
	    */
	
	  }, {
	    key: 'addDetailsEventListeners',
	    value: function addDetailsEventListeners() {
	      var ref = $('#' + this.state.generatedId);
	      var that = this;
	
	      ref.find('.details__others__photo').off().on('click', function () {
	        var children = $(this).find('.row').children();
	
	        $(this).siblings().removeClass('active');
	        $(this).addClass('active');
	        $(window).trigger('case-view-changed');
	        that.setMainImage(children);
	      });
	
	      $('.details__navigation__btn').off().on('click', function (e) {
	        if (e) {
	          e.preventDefault();
	        }
	
	        var nextAction = $(this).attr('data-action');
	
	        if (nextAction) {
	          $(window).trigger('case-changed');
	          that.handleDetailsNavigation(nextAction);
	        }
	      });
	    }
	
	    /**
	    This method is fired when the navigation on the details page is clicked. 
	    @param {action} - data attribute of the action the button is to be performed on. 
	    
	    It checks to see what the current case.sequence_value is. Then drops the current action into a switch statement. 
	    - next: checks if currentCaseSequence + 1 is less than or equal to the total cases in the category, then it loads the next case (that was loaded) and updates the URL via the history API.
	    - prev: checks if currentCaseSequence - 1 is greater than or equal to 1; if so, it loads the previous case (that was preloaded) and fires the loadSection method and updates the URL via the history API.
	    */
	
	  }, {
	    key: 'handleDetailsNavigation',
	    value: function handleDetailsNavigation(action) {
	      var that = this;
	      var currentCaseSequence = this.state.case.sequence_value;
	      var userFavorites = (0, _util.getUrlParameter)('favorites') ? '?favorites=true' : '';
	
	      //this.toggleLoading(true);
	
	      switch (action.toLowerCase()) {
	        case 'back':
	          break;
	        case 'next':
	          var totalCases = this.state.gallery.state.cases.cases_available;
	          if (currentCaseSequence + 1 <= totalCases || (0, _util.getUrlParameter)('favorites')) {
	            history.pushState(window.location.pathname, 'state', that.state.nextCase.canonical_url + userFavorites);
	
	            that.loadSection({
	              case: that.state.nextCase
	            });
	          }
	          break;
	        case 'prev':
	          if (currentCaseSequence - 1 >= 1 || (0, _util.getUrlParameter)('favorites')) {
	            history.pushState(window.location.pathname, 'state', that.state.prevCase.canonical_url + userFavorites);
	            that.loadSection({
	              case: that.state.prevCase
	            });
	          }
	          break;
	        default:
	          break;
	      }
	    }
	
	    /**
	    Fired during the loadSection method
	    @param {views} - array of images for a case.
	      This will loop through all views (potentially multiple images in each view) and in each view there will be 4 returned image sizes, this creates the html5 srcset data attribute so the browser can determine which image size to display. 
	    */
	
	  }, {
	    key: 'generateSrcsetPhotos',
	    value: function generateSrcsetPhotos(views) {
	      var _this4 = this;
	
	      var orderedViews = views.sort(function (a, b) {
	        return a.view_number - b.view_number;
	      });
	
	      var allImages = '';
	
	      orderedViews.map(function (view, viewIndex) {
	        var classNames = '';
	        if (viewIndex === 0) {
	          classNames += 'active';
	        }
	        var viewWrapper = '<div data-index="' + viewIndex + '" class="details__others__photo ' + classNames + '"><div class="row collapse">';
	
	        for (var i = 0; i < view.images.length; i++) {
	          var currentImage = view.images[i];
	
	          var thumbnail = currentImage.srcset.filter(function (imageItem) {
	            return imageItem.size.toLowerCase() === 'thumbnail';
	          })[0].path || undefined;
	          var defaultThumbnail = currentImage.srcset.filter(function (imageItem) {
	            return imageItem.size.toLowerCase() === 'detail';
	          })[0].path || undefined;
	          var detail = currentImage.srcset.filter(function (imageItem) {
	            return imageItem.size.toLowerCase() === 'huge';
	          })[0].path || undefined;
	
	          var singleImage = '<div data-large="' + _this4.state.apiUrl + detail + '" data-caption="' + (currentImage.caption || currentImage.type) + '" data-photo-type="' + currentImage.type + '" class="columns"><img \n        src="' + _this4.state.apiUrl + thumbnail + '" \n        srcset="' + _this4.state.apiUrl + defaultThumbnail + ' 1x,\n        ' + _this4.state.apiUrl + detail + ' 2x"\n        alt="' + (_this4.state.gallery.state.cases.category_name || 'Patient') + ' ' + currentImage.type + ' Photo | ' + _this4.state.gallery.state.practice.locality.city + ', ' + _this4.state.gallery.state.practice.locality.state + ' | ' + _this4.state.gallery.state.practice.name + '"\n        title="' + (_this4.state.gallery.state.cases.category_name || 'Patient') + ' ' + currentImage.type + ' Photo | ' + _this4.state.gallery.state.practice.locality.city + ', ' + _this4.state.gallery.state.practice.locality.state + ' | ' + _this4.state.gallery.state.practice.name + '" />\n        </div>';
	
	          viewWrapper += singleImage;
	        }
	
	        viewWrapper += '</div><div>View ' + (viewIndex + 1) + ' of ' + orderedViews.length + '</div></div>';
	
	        allImages += viewWrapper;
	      });
	
	      return allImages;
	    }
	
	    /**
	      Sets the "main" image of the case. 
	      @param - {object} - $children of jQuery selector
	        - If no children are passed in, it will get the first set of images and set those as the main image.
	      - If images are passed in it will loop through and get the "data-large" version of the image and update the current "main" images. 
	        There's an animate height that checks the current images height and hardcodes the height of the container. Then once the images are loaded, it then animates the containers height to the new height of the "main" images.
	    */
	
	  }, {
	    key: 'setMainImage',
	    value: function setMainImage($children) {
	      var $ref = $('#' + this.state.generatedId);
	      var images = '<div class="details__main--row">';
	      var hasBeenCalled = false;
	
	      if ($children === undefined) {
	        $children = $ref.find('.details__others__photo').first().find('.row').children();
	      }
	
	      var that = this;
	
	      $children.each(function (index, child) {
	        var imageUrl = $(child).attr('data-large');
	        var imageType = $(child).attr('data-photo-type');
	        var imageCaption = $(child).attr('data-caption');
	
	        var mainImageTemplate = '\n      <div class="details__main__img">\n        <img src="' + imageUrl + '"\n        alt="' + (that.state.gallery.state.cases.category_name || 'Patient') + ' ' + (imageType || '') + ' Photo | ' + that.state.gallery.state.practice.locality.city + ', ' + that.state.gallery.state.practice.locality.state + ' | ' + that.state.gallery.state.practice.name + '"\n        title="' + (that.state.gallery.state.cases.category_name || 'Patient') + ' ' + (imageType || '') + ' Photo | ' + that.state.gallery.state.practice.locality.city + ', ' + that.state.gallery.state.practice.locality.state + ' | ' + that.state.gallery.state.practice.name + '"\n        />\n        <p>' + imageCaption + '</p>\n      </div>';
	
	        images += mainImageTemplate;
	      });
	
	      images += '</div>';
	
	      var $main = $ref.find('.details__main');
	
	      $main.css({
	        height: $main.outerHeight() || 'auto'
	      });
	
	      $main.html(images);
	
	      function animateHeight() {
	        var height = $main.find('.details__main--row').outerHeight();
	        if (!hasBeenCalled) {
	          hasBeenCalled = true;
	          $main.animate({
	            height: height
	          }, 250);
	
	          setTimeout(function () {
	            $main.css({
	              height: 'auto'
	            });
	          }, 300);
	        }
	      }
	
	      $main.find('.details__main__img img').on('load', animateHeight);
	    }
	
	    /**
	    @param {attributes} - array of attributes
	    This is fired in the `loadSection` method. 
	      This will loop through all the attributes and pumps them into a table. 
	    */
	
	  }, {
	    key: 'generateAttributeDetails',
	    value: function generateAttributeDetails(attributes) {
	      var allAttr = '';
	      attributes.map(function (attr) {
	        if (attr.active && attr.attribute_value !== '' && attr.attribute_value !== null) {
	          switch (attr.attribute_name) {
	            case "Height":
	              if (attr.attribute_value.length === 0 || attr.attribute_value == 0) attr.attribute_value = "n/a";else attr.attribute_value = Math.floor(attr.attribute_value / 12) + " ft " + attr.attribute_value % 12 + " in";
	          }
	          var attributeTemplate = '<tr>\n        <th>' + attr.attribute_name + '</th>\n        <td>' + attr.attribute_value + '</td>\n        </tr>';
	
	          allAttr += attributeTemplate;
	        }
	      });
	
	      return allAttr;
	    }
	
	    /**
	      @param {content} - Template for the details page. 
	      - Checks if is last or first case to add the disabled state to the details navigation. 
	      - Checks to see if the gallery has the currentCategoryCanonical link defined in the gallery state, if it is, it sets the back button to it, otherwise it parses the current case URL and removes the case id and appends it as the back button href. 
	    */
	
	  }, {
	    key: 'template',
	    value: function template(content) {
	      var _this5 = this;
	
	      var that = this;
	      var $ref = $('#' + this.state.generatedId);
	
	      var isLastCase = that.state.case.sequence_value && that.state.case.sequence_value !== that.state.gallery.state.cases.cases_available ? '' : 'disabled';
	      var isFirstCase = that.state.case.sequence_value && that.state.case.sequence_value !== 1 ? '' : 'disabled';
	
	      if ((0, _util.getUrlParameter)('favorites')) {
	        var user = this.cookie.getJSON('gallery-user');
	
	        if (user.favorites.indexOf(this.state.case.case_id) + 1 === user.favorites.length) {
	          isLastCase = 'disabled';
	        } else {
	          isLastCase = '';
	        }
	
	        if (user.favorites.indexOf(this.state.case.case_id) === 0) {
	          isFirstCase = 'disabled';
	        } else {
	          isFirstCase = '';
	        }
	      }
	
	      var windowPathname = window.location.pathname.split('/');
	      var currentCategory = windowPathname.reverse().slice(1, windowPathname.length).reverse().join('/');
	
	      var cameFromFavorites = (0, _util.getUrlParameter)('favorites');
	
	      // Set up the back button - we have to look up the category name of the category we came from
	      var currentCategoryName = undefined;
	      var currentCategoryCanonical = undefined;
	
	      var categoryLookup = this.state.gallery.state.categories.map(function (category) {
	        return category.subcategories.map(function (subcategory) {
	          if (_this5.state.gallery.state.currentCategoryCanonical === undefined && subcategory.category_canonical_url == currentCategory) {
	            currentCategoryName = subcategory.category_name;
	            currentCategoryCanonical = subcategory.category_canonical_url;
	            that.updateState({
	              currentCategory: subcategory.category_id
	            });
	          } else if (subcategory.category_canonical_url == _this5.state.gallery.state.currentCategoryCanonical) {
	            currentCategoryName = subcategory.category_name;
	            currentCategoryCanonical = subcategory.category_canonical_url;
	            that.updateState({
	              currentCategory: subcategory.category_id
	            });
	          }
	        });
	      });
	
	      var backButton = this.state.gallery.state.currentCategoryCanonical || currentCategoryCanonical;
	      var backButtonText = cameFromFavorites ? "Favorites" : currentCategoryName === undefined ? "Gallery" : currentCategoryName + " Gallery";
	
	      if (cameFromFavorites) {
	        backButton = this.state.gallery.state.baseUrl + '/my-account/favorites';
	      }
	
	      updateTitle(content.title, this.state.gallery.state.galleryTitle);
	      updateOtherPhotos(content.photos);
	      updateFavoritesData(content.isAFavoriteCase, content.id);
	      updateAttr(content.attr);
	      updateDescription(content.description);
	      updateVideo(content.video);
	      updateNavigation(isFirstCase, isLastCase, backButton, backButtonText);
	
	      // $ref.html(template);
	      $ref.find('.details__center-content__btn').html(this.cloneConsultationButton());
	      this.state.gallery.addLinkEventListeners();
	      this.cloneDetailsNavigation();
	      this.addDetailsEventListeners();
	      //this.toggleLoading(false);
	
	      function updateTitle(title, subtitle) {
	        //$ref.find('.details__title').text(title);
	        $('#photo-gallery__title').text(title);
	        $('#photo-gallery__subtitle').html(subtitle);
	      }
	
	      function updateOtherPhotos(photos) {
	        $ref.find('.details__others').html(photos);
	      }
	
	      function updateFavoritesData(isAFavorite, caseId) {
	        var $favRef = $ref.find('.gallery-favorites');
	        if (isAFavorite) {
	          if (!$favRef.hasClass('active')) {
	            $favRef.addClass('active');
	          }
	          if (!$favRef.find('.heart-icon').hasClass('active')) {
	            $favRef.find('.heart-icon').addClass('active');
	          }
	        } else {
	          $favRef.find('.heart-icon').removeClass('active');
	          $favRef.removeClass('active');
	        }
	
	        $favRef.attr('data-id', caseId);
	      }
	
	      function updateAttr(attr) {
	        $ref.find('.details__attributes table.data').html(attr);
	      }
	
	      function updateDescription(desc) {
	        $ref.find('.details__content').html(desc);
	      }
	
	      function updateVideo(video) {
	        if (video) {
	          $ref.find('.details__video').html(video);
	        }
	      }
	
	      function updateNavigation(isFirstCase, isLastCase, backButtonLink, backButtonText) {
	        if (isFirstCase === '') {
	          $ref.find('.details__navigation__btn.prev').removeClass('disabled');
	        } else {
	          if (!$ref.find('.details__navigation__btn.prev').hasClass('disabled')) {
	            $ref.find('.details__navigation__btn.prev').addClass('disabled');
	          }
	        }
	
	        if (isLastCase === '') {
	          $ref.find('.details__navigation__btn.next').removeClass('disabled');
	        } else {
	          if (!$ref.find('.details__navigation__btn.next').hasClass('disabled')) {
	            $ref.find('.details__navigation__btn.next').addClass('disabled');
	          }
	        }
	
	        $ref.find('.details__navigation__link').attr('href', backButtonLink);
	        $ref.find('.details__navigation__link').text('Back to ' + backButtonText);
	      }
	    }
	
	    /**
	    This is responsible for cloning the "Previous" and "next" buttons into the topbar on the details page.
	      WARNING -- breaking conduct here -- Cloning some elements into another component (topbar to be specific). 
	    */
	
	  }, {
	    key: 'cloneDetailsNavigation',
	    value: function cloneDetailsNavigation() {
	      var $ref = $('#' + this.state.generatedId);
	      var allNavigation = $ref.find('.details__navigation').clone(true);
	      var backToSearchButton = $ref.find('.details__navigation__link.back').clone(true);
	
	      var $topbar = $('#topbar-mount');
	
	      $topbar.find('.topbar__account__backtosearch').html(backToSearchButton);
	      $topbar.find('.topbar__details__navigation').html(allNavigation);
	    }
	
	    /**
	    Override the ViewConstructor render function.
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return '\n      <div class="details">\n        <p><em>*Keep in mind that each patient is unique and your results may vary.</em></p>\n        \n        <div class="details__main"></div>\n        <div class="details__others">\n          \n        </div>\n        \n        <div class="details__center-content">\n          <p class="favorites gallery-favorites " data-id=""><span class="heart-icon "> <strong class="add">Add to favorites</strong> <strong class="favorite">Favorited</strong></span></p>      \n    \n          <div class="details__center-content__btn"></div>\n\n          <hr />\n        </div>\n        \n        <div class="details__attributes">\n          <h2>Case Details</h2>\n          <div class="details__content">\n            \n          </div>\n          <table class="data">\n            \n          </table>\n        </div>\n\n        <div class="details__video">\n          \n        </div>\n\n        <p><em>*Keep in mind that each patient is unique and your results may vary. Photos in our online gallery are of actual patients of our practice who have provided consent to display their pictures online.</em></p>\n\n        <hr />\n\n        <div class="details__navigation">\n          <a class="details__navigation__btn prev " data-action="prev">Previous Case</a>\n          <a class="details__navigation__btn next " data-action="next">Next Case</a>\n          <a href="" class="details__navigation__link back" data-action="back">Back to </a>\n        </div>\n      </div>\n    ';
	    }
	  }]);
	
	  return DetailsPage;
	}(_ViewConstructor3.default);
	
	exports.default = DetailsPage;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ViewConstructor2 = __webpack_require__(1);
	
	var _ViewConstructor3 = _interopRequireDefault(_ViewConstructor2);
	
	var _util = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/** Class representing the GallerySidebar */
	var GallerySidebar = function (_ViewConstructor) {
	  _inherits(GallerySidebar, _ViewConstructor);
	
	  function GallerySidebar() {
	    _classCallCheck(this, GallerySidebar);
	
	    return _possibleConstructorReturn(this, (GallerySidebar.__proto__ || Object.getPrototypeOf(GallerySidebar)).apply(this, arguments));
	  }
	
	  _createClass(GallerySidebar, [{
	    key: 'componentDidMount',
	
	    /**
	    componentDidMount - override method of ViewConstructor
	    */
	    value: function componentDidMount() {
	      var that = this;
	
	      this.getSidebarData();
	
	      $(window).bind('update-filters', function () {
	        if (that.state.gallery) {
	          that.renderFilters(that.state.gallery.state.cases.filters);
	        }
	      });
	    }
	
	    /**
	    getSidebarData
	    - Using the api object that is passed in this method will reach out to the API and get all procedure categories. Once the data is received it will update the galleries state (which saves the categories and is referenced elsewhere). 
	    - This also triggers the enterScreen method then fires the gallery addLinkEventListeners method applying event listers to all new links added here. 
	      refactor oportunity: Use some sort of shared state in the browsers local storage.
	    */
	
	  }, {
	    key: 'getSidebarData',
	    value: function getSidebarData() {
	      var that = this;
	
	      this.state.api.getCategories(function (categoriesRes) {
	        that.renderProcedures(categoriesRes);
	
	        that.state.gallery.update({
	          categories: categoriesRes
	        });
	
	        if (that.state.isBasic === false) that.enterScreen();
	
	        $('#' + that.state.generatedId + ' .sidebar__consultation').html(that.cloneConsultationButton());
	        that.state.gallery.addLinkEventListeners();
	      });
	    }
	
	    /**
	    Category List listener
	    adds an event listener to category titles in sidebar for collapsing and expanding the categories.
	    */
	
	  }, {
	    key: 'categoryListeners',
	    value: function categoryListeners() {
	      var $ref = $('#' + this.state.generatedId);
	      $ref.find('.category__name').off().on('click', function (e) {
	        if (e) {
	          e.preventDefault();
	        }
	        $(this).closest('.category').toggleClass('open');
	
	        if ($(this).closest('.category').hasClass('open')) {
	          $(this).siblings('.category__list').slideToggle(175);
	        } else {
	          $(this).siblings('.category__list').slideToggle(100);
	        }
	      });
	    }
	
	    /**
	    Filter List listener
	    adds an event listener to filter titles in sidebar for collapsing and expanding the categories.
	    */
	
	  }, {
	    key: 'filtersListeners',
	    value: function filtersListeners() {
	      var that = this;
	
	      var filtersContainer = $('#' + this.state.generatedId + ',#gallery-mobile-filters');
	      var mobileFiltersContainer = $('#gallery-mobile-filters');
	      var desktopFiltersContainer = $('#' + this.state.generatedId);
	
	      var filtersListClone = that.$ref.find('.sidebar__filters__list').children().clone(true);
	
	      mobileFiltersContainer.find('.sidebar__filters__list').html(filtersListClone);
	
	      filtersContainer.find('.filter__name').off().on('click', function (e) {
	        if (e) {
	          e.preventDefault();
	        }
	
	        $(this).closest('.filter').toggleClass('open');
	
	        if ($(this).closest('.filter').hasClass('open')) {
	          $(this).siblings('.filter__list--container').slideToggle(175);
	        } else {
	          $(this).siblings('.filter__list--container').slideToggle(100);
	        }
	      });
	
	      filtersContainer.find('.filter__list__item').off().on('click', function (e) {
	        if (e) {
	          e.preventDefault();
	        }
	        if (!$(this).hasClass('inactive') && !$(this).hasClass('perma-inactive')) {
	          $(this).toggleClass('active');
	          $(this).siblings().toggleClass('inactive');
	
	          activateCounterPart($(this));
	
	          that.activeFilterChecker();
	        }
	      });
	
	      function activateCounterPart($el) {
	        var withinDesktopFiltersList = $el.closest('.sidebar__filters__list').hasClass('gallery-desktop');
	        var currentId = $el.attr('data-filterid');
	
	        if (withinDesktopFiltersList) {
	          mobileFiltersContainer.find('.filter__list__item[data-filterid="' + currentId + '"]').toggleClass('active');
	        } else {
	          desktopFiltersContainer.find('.filter__list__item[data-filterid="' + currentId + '"]').toggleClass('active');
	        }
	      }
	
	      $(window).bind('clear-filters', function (e) {
	        filtersContainer.find('.filter__list__item.active').removeClass('active');
	        that.activeFilterChecker();
	      });
	
	      filtersContainer.find('.sidebar__clearall--link').off().on('click', function (e) {
	        $(window).trigger('clear-filters');
	      });
	
	      // Happens on mobile/tablet only
	      filtersContainer.find('.sidebar__filters__button').off().on('click', function (e) {
	        if (e) {
	          e.preventDefault();
	        }
	
	        $('body').toggleClass('body-noscroll-tablet');
	        mobileFiltersContainer.toggleClass('active');
	      });
	
	      that.activeFilterChecker();
	    }
	
	    /**
	    This is responsible for check all on page selected items in the filters section. 
	      - Appends the current selected item to the ".filter__list__active" within the targeted filter section 
	      - Adds event listener to remove that item and deselect the selected item's counterpart (need to figure out how to connect the two... ).
	    - Checks if "Clear All" button needs to be added and it will remove all active items then refire the default getCases without any content.
	    - Then fires another function which collects all filter data items and sends it to the category getCases method.
	    */
	
	  }, {
	    key: 'activeFilterChecker',
	    value: function activeFilterChecker() {
	      var allFiltersRef = $('#' + this.state.generatedId + ',#gallery-mobile-filters');
	      var $sidebarRefDesktop = this.$ref.find('.sidebar__filters');
	
	      var that = this;
	
	      // getting all the active and appending if they have not been appended.
	      allFiltersRef.find('.filter__list__item.active').each(function (index, currentFilter) {
	        var currentId = $(currentFilter).attr('data-filterid');;
	
	        var findParentSelectedContainer = $(currentFilter).closest('.filter__list--container').siblings('.filter__list__active');
	
	        if (!findParentSelectedContainer.find('.sidebar__selected--single[data-filteridcounterpart="' + currentId + '"]').length) {
	
	          var newItem = '\n        <div class="sidebar__selected--single" data-filteridcounterpart="' + currentId + '">\n          <a>' + $(currentFilter).text() + '</a>\n        </div>';
	
	          // .sidebar__clearall
	          $(currentFilter).closest('.sidebar__filters__list').siblings('.sidebar__clearall').append(newItem);
	          findParentSelectedContainer.append(newItem);
	        }
	      });
	
	      // checking to make sure the filter is still active
	      allFiltersRef.find('.sidebar__selected--single').each(function (index, currentFilter) {
	        var currentId = $(currentFilter).attr('data-filteridcounterpart');;
	
	        if (!$('.filter__list__item[data-filterid="' + currentId + '"]').hasClass('active')) {
	          $(currentFilter).remove();
	          $('.filter__list__item[data-filterid="' + currentId + '"]').siblings().removeClass('inactive');
	        }
	      });
	
	      allFiltersRef.find('.sidebar__selected--single').off().on('click', function (e) {
	        if (e) {
	          e.preventDefault();
	        }
	
	        var currentId = $(this).attr('data-filteridcounterpart');
	
	        allFiltersRef.find('.filter__list__item[data-filterid="' + currentId + '"]').removeClass('active');
	        that.activeFilterChecker();
	      });
	
	      // add clear all button if more than 1 selected
	      if ($sidebarRefDesktop.find('.sidebar__selected--single').length > 0) {
	        allFiltersRef.find('.sidebar__clearall').show();
	        history.pushState(null, null, window.location.pathname + '?filters');
	        this.updateState({
	          addedFilters: true
	        });
	      } else {
	        // otherwise hide clear all
	        allFiltersRef.find('.sidebar__clearall').hide();
	        if ((0, _util.getUrlParameter)('filters')) {
	          history.pushState(null, null, window.location.pathname);
	        }
	      }
	
	      that.generateFiltersRequestObject();
	    }
	
	    /**
	    generateFiltersRequestObject
	      This loops through all active filter items and collects the data within the data attribute on the item. 
	    */
	
	  }, {
	    key: 'generateFiltersRequestObject',
	    value: function generateFiltersRequestObject() {
	      var $ref = this.$ref.find('.sidebar__filters');
	      var that = this;
	
	      var finalRequestObject = [];
	
	      $ref.find('.filter__list__item.active').each(function (index, currentFilter) {
	        var parentFilterObj = JSON.parse($(currentFilter).closest('.filter__list').attr('data-filterobj'));
	        var filterValue = JSON.parse(decodeURI($(currentFilter).attr('data-request')));
	
	        parentFilterObj.filter_values.push(filterValue);
	
	        var foundInFinalObj = false;
	
	        for (var i = 0; i < finalRequestObject.length; i++) {
	          if (finalRequestObject[i].attribute_name === parentFilterObj.attribute_name) {
	            foundInFinalObj = true;
	            finalRequestObject[i].filter_values.push(filterValue);
	          }
	        }
	
	        if (!foundInFinalObj) {
	          finalRequestObject.push(parentFilterObj);
	        }
	      });
	
	      if (finalRequestObject.length > 0) {
	        // saving last instance
	        that.state.gallery.update({
	          lastSetOfCases: that.state.gallery.state.cases,
	          currentCategoryCanonical: window.location.href.replace(window.location.origin, '')
	        });
	
	        var getCasesRequest = {
	          category_id: this.state.gallery.state.cases.category_id,
	          filters: finalRequestObject,
	          case_count: that.state.gallery.state.cases.cases_available
	        };
	
	        that.state.category.resetCases();
	
	        this.state.api.getCases(getCasesRequest, function (res) {
	          if (res && res.case_count) {
	            that.state.category.updateCases(res);
	
	            that.state.gallery.update({
	              cases: res
	            });
	
	            that.state.category.generatePagination();
	            that.state.gallery.addLinkEventListeners();
	
	            $('.category__pagination').hide();
	          }
	        });
	      } else {
	        $('.category__pagination').show();
	
	        if (that.state.gallery.state.lastSetOfCases && that.state.gallery.state.lastSetOfCases.case_count !== that.state.gallery.state.cases.case_count) {
	
	          that.state.category.resetCases();
	
	          that.state.gallery.update({
	            cases: that.state.gallery.state.lastSetOfCases,
	            currentCategoryCanonical: window.location.href.replace(window.location.origin, '')
	          });
	          that.state.category.updateCases(that.state.gallery.state.cases);
	        }
	      }
	    }
	
	    /**
	    renderFilers
	    @param allFilers {array} - loops through array generating html markup for active filters and append them into the sidebar filters section. 
	    */
	
	  }, {
	    key: 'renderFilters',
	    value: function renderFilters(allFilters) {
	      var that = this;
	      // confirm we are getting an array
	      if (Array.isArray(allFilters)) {
	        var finalList = '';
	        var multipleFiltersList = {};
	
	        allFilters.map(function (filter, index) {
	          if (filter.active) {
	
	            if (isMultiple(filter.attribute_name)) {
	              // 1. remove before/after from attribute_name
	              // 2. determine if value exists in temp object,
	              // 2. a. If it does, add this to appropriate section then run generating function
	              // 2. b. If not create new key for filter values.
	
	              var currentFilter = determineBeforeOrAfter(filter);
	              var targetFilterName = currentFilter.attribute_name.replace(/-/g, '');
	
	              if (multipleFiltersList[targetFilterName] !== undefined) {
	                // if found...
	                multipleFiltersList[targetFilterName][currentFilter.type] = currentFilter.filter_values;
	                multipleFiltersList[targetFilterName][currentFilter.type + 'orig'] = filter;
	
	                finalList += that.generateFilterMultipleContainer(multipleFiltersList[targetFilterName]);
	              } else {
	                // otherwise create a new object
	                multipleFiltersList[targetFilterName] = {};
	                multipleFiltersList[targetFilterName].name = currentFilter.attribute_name;
	                multipleFiltersList[targetFilterName][currentFilter.type] = currentFilter.filter_values;
	                multipleFiltersList[targetFilterName][currentFilter.type + 'orig'] = filter;
	              }
	            } else {
	              finalList += that.generateFilterSingleContainer(filter, that.generateFilterListMarkup(filter.filter_values));
	            }
	          }
	        });
	
	        var filtersMount = $('#' + that.state.generatedId + ' .sidebar__filters__list');
	
	        filtersMount.html(finalList);
	        this.filtersListeners();
	      }
	
	      function isMultiple(filterName) {
	        if (filterName.toLowerCase().indexOf('before') !== -1) {
	          return true;
	        } else if (filterName.toLowerCase().indexOf('after') !== -1) {
	          return true;
	        } else {
	          return false;
	        }
	      }
	
	      function determineBeforeOrAfter(filter) {
	        var beforeOrAfter = undefined;
	        var filterName = filter.attribute_name.toLowerCase();
	        var after = 'after';
	        var before = 'before';
	
	        var obj = {
	          attribute_name: '',
	          filter_values: filter.filter_values,
	          type: undefined
	        };
	
	        if (filterName.indexOf('before') !== -1) {
	          var currentBeforeIndex = filterName.indexOf(before);
	          var nameWithoutBefore = filterName.slice(0, -(before.length + 1));
	
	          obj.type = before;
	          obj.attribute_name = nameWithoutBefore.replace(/ /g, '-');
	        } else if (filterName.toLowerCase().indexOf(after) !== -1) {
	          var currentAfterIndex = filterName.indexOf(after);
	          var nameWithoutAfter = filterName.slice(0, -(after.length + 1));
	
	          obj.type = after;
	          obj.attribute_name = nameWithoutAfter.replace(/ /g, '-');
	        }
	
	        return obj;
	      }
	    }
	  }, {
	    key: 'generateFilterListMarkup',
	    value: function generateFilterListMarkup(filterList) {
	      var filterHtml = '';
	
	      filterList.sort(function (a, b) {
	        return a.sort - b.sort;
	      }).map(function (filterValue) {
	        var activeClass = filterValue.selected ? 'active' : '';
	        var isInactive = filterValue.case_count >= 1 ? '' : 'perma-inactive inactive';
	
	        var futureRequestObj = Object.assign({}, filterValue, {
	          display_name: filterValue.display_name,
	          selected: true
	        });
	
	        var stringifiedRequestObj = JSON.stringify(futureRequestObj);
	
	        filterHtml += '\n        <li data-request="' + encodeURI(stringifiedRequestObj) + '" data-filterid="filter-' + (0, _util.generateUID)() + '" class="filter__list__item ' + activeClass + isInactive + '">' + filterValue.display_name + '</li>\n      ';
	      });
	
	      return filterHtml;
	    }
	  }, {
	    key: 'generateFilterSingleContainer',
	    value: function generateFilterSingleContainer(filter, generatedFilterList) {
	      var filterWithoutValues = Object.assign({}, filter, {
	        filter_values: []
	      });
	
	      return '\n      <li class="filter">\n        <h3 class="filter__name">' + filter.attribute_name + '</h3>\n        <div class="filter__list__active"></div>\n        <div class="filter__list--container" style="display: none;">\n          <ul class="filter__list" data-filterobj=\'' + JSON.stringify(filterWithoutValues) + '\'>' + generatedFilterList + '</ul>\n        </div>\n      </li>\n    ';
	    }
	  }, {
	    key: 'generateFilterMultipleContainer',
	    value: function generateFilterMultipleContainer(multipleFilterObj) {
	      var beforeFilterWithoutValues = Object.assign({}, multipleFilterObj.beforeorig, {
	        filter_values: []
	      });
	      var afterFilterWithoutValues = Object.assign({}, multipleFilterObj.afterorig, {
	        filter_values: []
	      });
	
	      return '\n      <li class="filter">\n        <h3 class="filter__name filter__name--multiple">' + multipleFilterObj.name.replace(/-/g, ' ') + '</h3>\n        <div class="filter__list__active"></div>\n        <div class="filter__list--container filter__list__multiple" style="display: none;">\n          <div class="filter__list__multiple__before">\n            <p><strong>Before</strong></p>\n            <ul class="filter__list" data-filterobj=\'' + JSON.stringify(beforeFilterWithoutValues) + '\'>\n              ' + this.generateFilterListMarkup(multipleFilterObj.before) + '\n            </ul>\n          </div>\n          <div class="filter__list__multiple__after">\n            <p><strong>After</strong></p>\n            <ul class="filter__list" data-filterobj=\'' + JSON.stringify(afterFilterWithoutValues) + '\'>\n              ' + this.generateFilterListMarkup(multipleFilterObj.after) + '\n            </ul>\n          </div>\n        </div>\n      </li>\n    ';
	    }
	
	    /**
	    renderProcedures
	    @param proceduresArray {array} - loops through array and orders them based on the returned sequence_value
	      - this also generates the procedures category menu html
	    */
	
	  }, {
	    key: 'renderProcedures',
	    value: function renderProcedures(proceduresArray) {
	      if (proceduresArray && proceduresArray.length) {
	        var _generateCategoryMenu = function _generateCategoryMenu(subCategoryArr) {
	          var allSubLinks = '';
	          for (var _i = 0; _i < subCategoryArr.length; _i++) {
	            var currentCategory = subCategoryArr[_i];
	            var isAdult = currentCategory.adult ? 'adult' : '';
	
	            var linkTemplate = '\n            <li class="category__list__item">\n              <a href="' + currentCategory.category_canonical_url + '" data-id="' + currentCategory.category_id + '" class="category__list__item__link ' + isAdult + '">\n                ' + currentCategory.category_name + '\n              </a>\n            </li>';
	
	            allSubLinks += linkTemplate;
	          }
	
	          return allSubLinks;
	        };
	
	        var allProcedures = proceduresArray.sort(function (a, b) {
	          return a.sequence_value - b.sequence_value;
	        });
	        var children = '';
	
	        for (var i = 0; i < allProcedures.length; i++) {
	          var currentCategoryParent = proceduresArray[i];
	          var currentCategoryChildren = currentCategoryParent.subcategories.sort(function (a, b) {
	            return a.sequence_value - b.sequence_value;
	          });
	
	          var isFirstCategory = i === 0;
	
	          var categoryTemplate = '<li class="category ' + (isFirstCategory ? 'open' : '') + '">\n          <h3 class="category__name">' + currentCategoryParent.category_name + '</h3>\n          <ul class="category__list" ' + (isFirstCategory ? '' : 'style="display: none;"') + '>\n            ' + _generateCategoryMenu(currentCategoryChildren) + '\n          </ul>\n        </li>';
	
	          children += categoryTemplate;
	        }
	
	        var finalList = children;
	
	        var $ref = $('#' + this.state.generatedId);
	
	        $ref.find('.sidebar__categories__list').html(finalList);
	
	        this.categoryListeners();
	      }
	    }
	
	    /**
	      When within the categories page a button is displayed to go back to the landing page. This is called within the spine of the application on load and sets the back link to the landing page (which can be / or /gallery or whatever the developer sets it as).
	    */
	
	  }, {
	    key: 'setGalleryBackLink',
	    value: function setGalleryBackLink(link) {
	      var $ref = $('#' + this.state.generatedId);
	
	      $ref.find('.sidebar__categories__button, .sidebar__categories__selected-procedure').attr('href', link);
	    }
	
	    /**
	    This method is called if on the landing page, this sidebar is responsible for updating itself. 
	    If on landing page, this will make sure to only display the categories sidebar and hide the filters section as well as the back button
	    */
	
	  }, {
	    key: 'isLandingPage',
	    value: function isLandingPage() {
	      var $ref = $('#' + this.state.generatedId);
	      $ref.show();
	
	      // Hiding gallery back button & Filters
	      $ref.find('.sidebar__categories__button').slideUp();
	      $ref.find('.sidebar__filters').slideUp();
	
	      // showing entire category list
	      $ref.find('.sidebar__categories__list').slideDown();
	    }
	
	    /**
	    If on the category page it will update the back button text using `updateBackButtonText`, otherwise it will fetch to the API and get the categories then update the text. 
	      The only time it will reach out to the API to get the categories will be if the page is refreshed, or linked directly to it if on a categories page.
	    */
	
	  }, {
	    key: 'isCategoryPage',
	    value: function isCategoryPage(newState, gallery) {
	      var _this2 = this;
	
	      if ((0, _util.getUrlParameter)('filters')) {
	        this.activeFilterChecker();
	      }
	
	      if (this.state.gallery.state.categories.length) {
	        this.updateBackButtonText(this.state.gallery.state.categories);
	      } else {
	        this.state.api.getCategories(function (res) {
	          _this2.updateBackButtonText(res);
	        });
	      }
	
	      var $ref = $('#' + this.state.generatedId);
	      $ref.show();
	
	      // hide entire category list
	      $ref.find('.sidebar__categories__list').slideUp();
	
	      // Show gallery back button & Filters
	
	      $ref.find('.sidebar__categories__button').slideDown();
	      $ref.find('.sidebar__filters').slideDown();
	    }
	
	    /**
	      This will get the current route, with no parameters on it, then loop through all categories and put all subcategories in a single flattened array. 
	      It will then find the current category that matches the category_canonical_url to the route without a param ant update the button text.
	    */
	
	  }, {
	    key: 'updateBackButtonText',
	    value: function updateBackButtonText(allCategories) {
	      var $ref = $('#' + this.state.generatedId);
	      var nextRouteNoParam = this.state.gallery.state.currentCategoryCanonical.split('?')[0];
	
	      var allSubcategories = [];
	
	      for (var i = 0; i < allCategories.length; i++) {
	        allSubcategories.push(allCategories[i].subcategories);
	      }
	
	      allSubcategories = (0, _util.flattenMultiArray)(allSubcategories);
	
	      var backButtonText = $.grep(allSubcategories, function (subcategory) {
	        return subcategory.category_canonical_url === decodeURI(nextRouteNoParam);
	      });
	
	      if (backButtonText.length) {
	        backButtonText = backButtonText[0].category_name;
	      }
	
	      $ref.find('.sidebar__categories__button .gallery-desktop, .sidebar__categories__selected-procedure').text(backButtonText);
	    }
	
	    /**
	    If on account section, this needs to hide.
	    */
	
	  }, {
	    key: 'isAccountSection',
	    value: function isAccountSection() {
	      this.$ref.hide();
	    }
	
	    /**
	    if on cases page we will just hide the sidebar
	    */
	
	  }, {
	    key: 'isCasePage',
	    value: function isCasePage() {
	      var $ref = $('#' + this.state.generatedId);
	      $ref.hide();
	    }
	
	    /**
	    Initial render function contains the basic layout for the sidebar. If categories data exists, it will be parsed and `renderProcedures` method will fire.
	    */
	
	  }, {
	    key: 'render',
	    value: function render(categoriesData) {
	      return '\n      <div class="sidebar__categories">\n        <a href="" class="sidebar__categories__button" style="display: none;"><span class="gallery-mobile">Procedure</span><span class="gallery-desktop">&nbsp;</span></a>\n        \n        <div class="sidebar__selected categories_only">\n          <a href="" class="gallery-mobile sidebar__categories__selected-procedure"></a>\n        </div>\n\n        <ul class="sidebar__categories__list" style="display: none;">' + (this.renderProcedures(categoriesData) || '') + '</ul>\n      </div>\n      <div class="sidebar__filters" style="display: none;">\n        <h2 class="sidebar__title gallery-desktop">Filter Options</h2>\n        \n        <a href="" class="sidebar__filters__button"><span class="gallery-mobile">Filters</span><span class="gallery-desktop">&nbsp;</span></a>\n\n        <div class="sidebar__clearall" style="display: none;">\n          <a class="sidebar__clearall--link">Clear All</a>\n        </div>\n        <ul class="sidebar__filters__list gallery-desktop"></ul>\n      </div>\n      <div class="sidebar__consultation"></div>\n    ';
	    }
	  }]);
	
	  return GallerySidebar;
	}(_ViewConstructor3.default);
	
	exports.default = GallerySidebar;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ViewConstructor2 = __webpack_require__(1);
	
	var _ViewConstructor3 = _interopRequireDefault(_ViewConstructor2);
	
	var _jsCookie = __webpack_require__(3);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	  Class GalleryTopBar represents the top bar within the photo gallery. It will handle the account links for logging in, logging out, and viewing the favorites next to it as well as the details navigation on the top left when on the details page.
	*/
	var GalleryTopBar = function (_ViewConstructor) {
	  _inherits(GalleryTopBar, _ViewConstructor);
	
	  function GalleryTopBar() {
	    _classCallCheck(this, GalleryTopBar);
	
	    return _possibleConstructorReturn(this, (GalleryTopBar.__proto__ || Object.getPrototypeOf(GalleryTopBar)).apply(this, arguments));
	  }
	
	  _createClass(GalleryTopBar, [{
	    key: 'componentDidMount',
	
	    /**
	    Component did mount
	      @params {mountId} - accepts string as mount id
	    */
	    value: function componentDidMount() {
	      var that = this;
	      var $ref = $('#' + this.state.generatedId);
	
	      $(window).bind('user-changed', function () {
	        var user = that.cookie.getJSON('gallery-user');
	        that.updateFavCount();
	
	        if (user && user.email) {
	          that.$ref.find('.topbar__account__info__login').hide();
	          that.$ref.find('.topbar__account__info__logout').show();
	        } else if (user) {
	          that.$ref.find('.topbar__account__info__login .login').hide();
	          that.$ref.find('.topbar__account__info__login .create').show();
	        } else {
	          that.$ref.find('.topbar__account__info__login').show();
	          that.$ref.find('.topbar__account__info__logout').hide();
	
	          that.$ref.find('.topbar__account__info__login .create').hide();
	          that.$ref.find('.topbar__account__info__login .login').show();
	        }
	      });
	
	      $(window).bind('show-create-account', function () {
	        // if no cookie, show notification
	        if (!_jsCookie2.default.get('create-account-dismissed')) {
	          $('.create-account-notification').addClass('show');
	        }
	      });
	
	      $(window).bind('hide-create-account', function () {
	        $('.create-account-notification').removeClass('show');
	        _jsCookie2.default.set('create-account-dismissed', 'no-more-show');
	      });
	
	      $('.dismiss-create-account').on('click', function () {
	        $(window).trigger('hide-create-account');
	      });
	
	      if (!("ontouchstart" in document.documentElement)) {
	        $ref.find('.topbar__account__info__logout').on('mouseover', function () {
	          $ref.find('.topbar__account__info__logout').addClass('hover');
	        }).on('mouseleave', function () {
	          $ref.find('.topbar__account__info__logout').removeClass('hover');
	        });
	      } else {
	        $ref.find('.topbar__account__info__logout > div').on('click', function () {
	          $(this).closest('.topbar__account__info__logout').toggleClass('dropdown');
	        });
	      }
	
	      this.updateState({
	        favCount: 0
	      });
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var that = this;
	      var user = that.cookie.getJSON('gallery-user');
	
	      if (user && !user.email) {
	        that.$ref.find('.topbar__account__info__login .login').hide();
	        that.$ref.find('.topbar__account__info__login .create').show();
	      } else {
	        that.$ref.find('.topbar__account__info__login .create').hide();
	        that.$ref.find('.topbar__account__info__login .login').show();
	      }
	    }
	  }, {
	    key: 'updateFavCount',
	    value: function updateFavCount() {
	      var $ref = $('#' + this.state.generatedId);
	      var user = _jsCookie2.default.getJSON('gallery-user');
	
	      var favCount = $('.fav-count');
	
	      if (user) {
	        this.updateState({
	          favCount: user.favorites.length
	        });
	      } else {
	        this.updateState({
	          favCount: 0
	        });
	      }
	
	      favCount.text(this.state.favCount);
	    }
	  }, {
	    key: 'render',
	    value: function render(data) {
	      return '\n      <div class="topbar">' + (!this.state.isBasic ? '<div class="topbar__account">\n          <div class="topbar__account__backtosearch">&nbsp;</div>\n          <a class="topbar__account__backtohome" href="' + this.state.baseUrl + '">Back to Gallery Home</a>\n          <div class="topbar__account__info">\n            <div class="topbar__account__info--row">\n              <div class="topbar__account__info__favorites"><a href="' + this.state.baseUrl + '/my-account/favorites"><span class="heart-icon active"></span> <span class="fav-count">0</span> Favorites</a></div>\n              <div class="topbar__account__info__login">\n                <a href="' + this.state.baseUrl + '/my-account/login" class="login"><span class="account-icon"></span>Sign In</a>\n                <a href="' + this.state.baseUrl + '/my-account/create" class="create"><span class="account-icon"></span>Create Account</a>\n              </div>\n              <div class="topbar__account__info__logout">\n                <div><span class="account-icon"></span> My Account</div>\n                <ul>\n                  <li><a href="' + this.state.baseUrl + '">Gallery Home</a></li>\n                  <li><a href="' + this.state.baseUrl + '/my-account/favorites">My Favorites</a></li>\n                  <li><a href="' + this.state.baseUrl + '/my-account">Settings</a></li>\n                  <li><a href="' + this.state.baseUrl + '/my-account/logout">Sign Out</a></li>\n                </ul>\n              </div>\n            </div>\n          </div>\n          </div>' : '<div class="topbar__account"><a class="topbar__account__backtohome" href="' + this.state.baseUrl + '">Back to Gallery Home</a></div>') + '\n        <div class="topbar__details__navigation"></div>\n      </div>\n    ';
	    }
	  }]);
	
	  return GalleryTopBar;
	}(_ViewConstructor3.default);
	
	exports.default = GalleryTopBar;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _ViewConstructor2 = __webpack_require__(1);
	
	var _ViewConstructor3 = _interopRequireDefault(_ViewConstructor2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/** 
	  Class representing the Landing page
	*/
	var LandingPage = function (_ViewConstructor) {
	  _inherits(LandingPage, _ViewConstructor);
	
	  function LandingPage() {
	    _classCallCheck(this, LandingPage);
	
	    return _possibleConstructorReturn(this, (LandingPage.__proto__ || Object.getPrototypeOf(LandingPage)).apply(this, arguments));
	  }
	
	  _createClass(LandingPage, [{
	    key: 'componentDidMount',
	
	
	    /** 
	    ## componentDidMount
	    This is an override of the ViewContructor method.
	    - fires consultationButton if it exists
	    */
	    value: function componentDidMount() {
	      this.$ref.find('.button-container').append(this.cloneConsultationButton());
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      _get(LandingPage.prototype.__proto__ || Object.getPrototypeOf(LandingPage.prototype), 'componentDidEnter', this).call(this);
	
	      $(window).trigger('landing-page-enter');
	    }
	  }, {
	    key: 'loadSection',
	    value: function loadSection(newRouteState, galleryConfig) {
	      var that = this;
	
	      var gallery = galleryConfig;
	
	      that.updateMeta(gallery.state.practice.locality.city + ', ' + gallery.state.practice.locality.state + ' Before-and-After photos', 'View the before-and-after photos of our patients in ' + gallery.state.practice.locality.city + ', ' + gallery.state.practice.locality.state);
	      that.updateCanoncial(window.location.origin + that.state.baseUrl);
	    }
	
	    /**
	    Renders a generic template. 
	    */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return '\n      <div id="gallery-landing-content">\n        <div class="gallery-home-top">\n          <p class="gallery-mobile">Select a procedure to begin your search</p>\n          <h2 class="gallery-desktop">Select a procedure to begin your search.</h2>\n        </div>\n        <div class="gallery-desktop next-step">\n          <p>Ready for the next step? Contact us to request your consultation.</p>\n\n          <div class="button-container"></div>\n        </div>\n      </div>\n    ';
	    }
	  }]);
	
	  return LandingPage;
	}(_ViewConstructor3.default);
	
	exports.default = LandingPage;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _util = __webpack_require__(2);
	
	var _jsCookie = __webpack_require__(3);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/** Class representing a site. */
	var Site = function () {
	  /**
	    Assigns siteInitalState
	    @param {func} config.dev - will log anywhwere you set log point
	    @param {func} config.onRouteChange - callback when routes change. This returns (oldRouteState, newRouteState, cb). Use the callback to let the Site class know that you are done and it can handle the click events.
	    @param {string} config.baseUrl - base url where the Site class will be initiated on and will high jack links that are clicked within.
	  */
	  function Site(config) {
	    _classCallCheck(this, Site);
	
	    this.state = {
	      _prefix: (0, _util.generateUID)(),
	      mount: undefined,
	      dev: false,
	      baseUrl: '/',
	      categories: [],
	      cases: {},
	      useAdultNag: false,
	      routeState: {
	        path: window.location.pathname,
	        currentComponentId: undefined
	      }
	    };
	
	    var that = this;
	    that.update(config);
	    that.addLinkEventListeners();
	
	    if (typeof this.state.onLoad === 'function') {
	      this.state.onLoad(this.state, this);
	    }
	
	    // listens for forward and back button in browser
	    window.addEventListener('popstate', function (e) {
	      // console.log(e);
	      that.routeChange();
	    });
	
	    this.routeChange();
	  }
	
	  /** 
	  Updates the state
	  @return updates `this.state`
	  */
	
	
	  _createClass(Site, [{
	    key: 'update',
	    value: function update(newState) {
	      this.state = Object.assign({}, this.state, newState);
	    }
	
	    /**
	    * method routeChange
	    * This should be fired when a route change happens; default is: 
	    * 1. When gallery initializes in the `contructor` method. 
	    * 2. When the popstate event is fired (gallery is listening for this). e.g. when you click back or forward using the history of the browser.
	    * 3. addLinkEventListener adds link event listeners to anchor links that have the baseUrl within the href. 
	    */
	
	  }, {
	    key: 'routeChange',
	    value: function routeChange(linkClickedObject) {
	      var _this = this;
	
	      var nextPath = linkClickedObject && linkClickedObject.href ? linkClickedObject.href : window.location.pathname;
	
	      var newRouteState = linkClickedObject || {};
	      var oldRouteState = this.state.routeState;
	
	      newRouteState.type = "newRouteState";
	      newRouteState.path = nextPath;
	
	      oldRouteState.type = "oldRouteState";
	
	      if (linkClickedObject) {
	        var historyObj = {
	          lastPath: this.state.routeState.path
	        };
	
	        history.pushState(historyObj, 'state', nextPath);
	      }
	
	      if (typeof this.state.onRouteChange === 'function') {
	
	        var that = this;
	
	        var $loading = $('#' + this.state.mount).find('div.loading');
	
	        $loading.css({ opacity: 1 });
	
	        this.state.onRouteChange(oldRouteState, newRouteState, function () {
	          _this.update({
	            routeState: newRouteState
	          });
	
	          that.addLinkEventListeners();
	          $loading.css({ opacity: 0 });
	        }, this);
	      }
	    }
	
	    /**
	    * addLinkEventListeners - loops through all anchor links, and if the anchor link contains the baseUrl (defined in the state) it will remove any event listeners on the anchor then apply a function defined within this method called `linkClicked`.
	      * linkCLicked {function} - checks if there is an ID attached to the link that was clicked. It removed the window.location.origin value from the href if it exists then fires the `Site.routeChange` method and passes an object containing an id if it exists and the remaining portion of the href which is just the path of the URL.
	    */
	
	  }, {
	    key: 'addLinkEventListeners',
	    value: function addLinkEventListeners() {
	      var _this2 = this;
	
	      var that = this;
	
	      function linkClicked(e) {
	        var href = this.attributes.href.value;
	        var id = this.attributes['data-id'] ? this.attributes['data-id'].value : undefined;
	
	        if (href.indexOf(that.state.baseUrl) !== -1) {
	          // console.log('base url is contained within the link');
	          // Handle on click event
	          e.preventDefault();
	        }
	
	        var currentLocation = window.location;
	
	        // this checks to see if the host name is part of the link
	        if (href.indexOf(currentLocation.origin) !== -1) {
	
	          // if it is, then remove it and pass it along
	          href = href.replace(currentLocation.origin, '');
	        }
	
	        var linkClickedObject = {
	          id: id,
	          href: href
	        };
	
	        if (linkClickedObject.href && that.state.routeState.path.replace(new RegExp('/', 'g'), '') !== linkClickedObject.href.replace(new RegExp('/', 'g'), '')) {
	
	          if (that.state.useAdultNag && this.attributes.class && this.attributes.class.value.indexOf('adult') !== -1) {
	            var confirmAdultNotice = function confirmAdultNotice() {
	              return confirm('This category contains nudity. Please click OK to confirm you are at least 18 years of age and are not offended by such material.');
	            };
	
	            if (_jsCookie2.default.get('adult_nag_warning') !== undefined) {
	              that.routeChange(linkClickedObject);
	            } else if (confirmAdultNotice()) {
	              that.routeChange(linkClickedObject);
	              _jsCookie2.default.set('adult_nag_warning', 'has-agreed');
	            }
	          } else {
	            that.routeChange(linkClickedObject);
	          }
	        }
	
	        if ($(this).hasClass('category__list__item__link')) {
	          $(window).trigger('category-selected');
	        }
	        $('.topbar__account__info__logout').removeClass('hover dropdown');
	      }
	
	      $('a').each(function (i, a) {
	        // Only adding and removing the event listeners from the anchor links that need it. Rules:
	        // - they must have an href
	        // - the href must contain the baseUrl
	        if (a.attributes.href && a.attributes.href.value.indexOf(_this2.state.baseUrl) !== -1) {
	          $(a).off().on('click', linkClicked); // removed all event listeners then add em back
	        }
	      });
	
	      this.addFavoriteLinkListeners();
	    }
	
	    /**
	      Adds link event listeners to all classes with "gallery-favorites". 
	    */
	
	  }, {
	    key: 'addFavoriteLinkListeners',
	    value: function addFavoriteLinkListeners() {
	      var that = this;
	
	      if (!this.state.isBasic) {
	        $('.gallery-favorites').each(function (index, favItem) {
	          $(favItem).off().on('click', handleFavoriteAction);
	        });
	      } else {
	        return;
	      }
	
	      function handleFavoriteAction(e) {
	        if (e) {
	          e.preventDefault();
	        }
	
	        $(this).toggleClass('active').find('.heart-icon').toggleClass('active');
	
	        var user = _jsCookie2.default.getJSON('gallery-user');
	        if (user) {
	          that.state.api.toggleFavorite($(this).attr('data-id'));
	
	          if (!user.email) {
	            $(window).trigger('show-create-account');
	          }
	        } else {
	          that.state.api.createTempUserAndAddFavorite($(this).attr('data-id'));
	
	          if ($(this).hasClass('dismiss-create-account')) {
	            $(window).trigger('hide-create-account');
	          } else {
	            $(window).trigger('show-create-account');
	          }
	        }
	      }
	    }
	  }]);
	
	  return Site;
	}();
	
	exports.default = Site;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js